const Et = ["0.3", "0.4", "0.5", "0.6", "1"], Mt = ["0.2", "0.3", "1"], pt = "1", Je = "1", gi = "metaframe.json", bi = "metapage/definition", vi = "metapage/state", Gt = Mt[Mt.length - 1], An = Et[Et.length - 1], Sn = /^[v^~<>=]*?(\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+))?(?:-([\da-z\-]+(?:\.[\da-z\-]+)*))?(?:\+[\da-z\-]+(?:\.[\da-z\-]+)*)?)?)?$/i, It = (e) => {
  if (typeof e != "string")
    throw new TypeError("Invalid argument expected string");
  const t = e.match(Sn);
  if (!t)
    throw new Error(`Invalid argument not valid semver ('${e}' received)`);
  return t.shift(), t;
}, Ct = (e) => e === "*" || e === "x" || e === "X", $t = (e) => {
  const t = parseInt(e, 10);
  return isNaN(t) ? e : t;
}, En = (e, t) => typeof e != typeof t ? [String(e), String(t)] : [e, t], Mn = (e, t) => {
  if (Ct(e) || Ct(t))
    return 0;
  const [n, s] = En($t(e), $t(t));
  return n > s ? 1 : n < s ? -1 : 0;
}, xt = (e, t) => {
  for (let n = 0; n < Math.max(e.length, t.length); n++) {
    const s = Mn(e[n] || "0", t[n] || "0");
    if (s !== 0)
      return s;
  }
  return 0;
}, V = (e, t) => {
  const n = It(e), s = It(t), i = n.pop(), o = s.pop(), r = xt(n, s);
  return r !== 0 ? r : i && o ? xt(i.split("."), o.split(".")) : i || o ? i ? -1 : 1 : 0;
};
var In = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ht(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Vt = { exports: {} };
(function(e, t) {
  (function(n, s) {
    e.exports = s();
  })(In, function() {
    var n = function(o, r) {
      if (r = r || {}, typeof o != "function")
        throw new i("fetch must be a function");
      if (typeof r != "object")
        throw new i("defaults must be an object");
      if (r.retries !== void 0 && !s(r.retries))
        throw new i("retries must be a positive integer");
      if (r.retryDelay !== void 0 && !s(r.retryDelay) && typeof r.retryDelay != "function")
        throw new i("retryDelay must be a positive integer or a function returning a positive integer");
      if (r.retryOn !== void 0 && !Array.isArray(r.retryOn) && typeof r.retryOn != "function")
        throw new i("retryOn property expects an array or function");
      var a = {
        retries: 3,
        retryDelay: 1e3,
        retryOn: []
      };
      return r = Object.assign(a, r), function(f, c) {
        var d = r.retries, y = r.retryDelay, w = r.retryOn;
        if (c && c.retries !== void 0)
          if (s(c.retries))
            d = c.retries;
          else
            throw new i("retries must be a positive integer");
        if (c && c.retryDelay !== void 0)
          if (s(c.retryDelay) || typeof c.retryDelay == "function")
            y = c.retryDelay;
          else
            throw new i("retryDelay must be a positive integer or a function returning a positive integer");
        if (c && c.retryOn)
          if (Array.isArray(c.retryOn) || typeof c.retryOn == "function")
            w = c.retryOn;
          else
            throw new i("retryOn property expects an array or function");
        return new Promise(function(_, S) {
          var v = function(b) {
            var A = typeof Request < "u" && f instanceof Request ? f.clone() : f;
            o(A, c).then(function(I) {
              if (Array.isArray(w) && w.indexOf(I.status) === -1)
                _(I);
              else if (typeof w == "function")
                try {
                  return Promise.resolve(w(b, null, I)).then(function(R) {
                    R ? x(b, null, I) : _(I);
                  }).catch(S);
                } catch (R) {
                  S(R);
                }
              else
                b < d ? x(b, null, I) : _(I);
            }).catch(function(I) {
              if (typeof w == "function")
                try {
                  Promise.resolve(w(b, I, null)).then(function(R) {
                    R ? x(b, I, null) : S(I);
                  }).catch(function(R) {
                    S(R);
                  });
                } catch (R) {
                  S(R);
                }
              else
                b < d ? x(b, I, null) : S(I);
            });
          };
          function x(b, A, I) {
            var R = typeof y == "function" ? y(b, A, I) : y;
            setTimeout(function() {
              v(++b);
            }, R);
          }
          v(0);
        });
      };
    };
    function s(o) {
      return Number.isInteger(o) && o >= 0;
    }
    function i(o) {
      this.name = "ArgumentError", this.message = o;
    }
    return n;
  });
})(Vt);
var Cn = Vt.exports;
const dt = /* @__PURE__ */ ht(Cn), B = {
  Remove: "remove",
  Replace: "replace",
  Add: "add"
}, Jt = Symbol.for("__MUTATIVE_PROXY_DRAFT__"), $n = Symbol("__MUTATIVE_RAW_RETURN_SYMBOL__"), Ue = Symbol.iterator, Y = {
  mutable: "mutable",
  immutable: "immutable"
}, mt = {};
function Ie(e, t) {
  return e instanceof Map ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function Lt(e, t) {
  if (t in e) {
    let n = Reflect.getPrototypeOf(e);
    for (; n; ) {
      const s = Reflect.getOwnPropertyDescriptor(n, t);
      if (s)
        return s;
      n = Reflect.getPrototypeOf(n);
    }
  }
}
function Q(e) {
  var t;
  return (t = e.copy) !== null && t !== void 0 ? t : e.original;
}
function ge(e) {
  return !!$(e);
}
function $(e) {
  return typeof e != "object" ? null : e == null ? void 0 : e[Jt];
}
function yt(e) {
  var t;
  const n = $(e);
  return n ? (t = n.copy) !== null && t !== void 0 ? t : n.original : e;
}
function ee(e, t) {
  if (!e || typeof e != "object")
    return !1;
  let n;
  return Object.getPrototypeOf(e) === Object.prototype || Array.isArray(e) || e instanceof Map || e instanceof Set || !!(t != null && t.mark) && ((n = t.mark(e, Y)) === Y.immutable || typeof n == "function");
}
function Wt(e, t = []) {
  if (Object.hasOwnProperty.call(e, "key")) {
    const n = e.parent.copy, s = $(pe(n, e.key));
    if (s !== null && (s == null ? void 0 : s.original) !== e.original)
      return null;
    const i = e.parent.type === 3, o = i ? Array.from(e.parent.setMap.keys()).indexOf(e.key) : e.key;
    if (!(i && n.size > o || Ie(n, o)))
      return null;
    t.push(o);
  }
  if (e.parent)
    return Wt(e.parent, t);
  t.reverse();
  try {
    xn(e.copy, t);
  } catch {
    return null;
  }
  return t;
}
function be(e) {
  return Array.isArray(e) ? 1 : e instanceof Map ? 2 : e instanceof Set ? 3 : 0;
}
function pe(e, t) {
  return be(e) === 2 ? e.get(t) : e[t];
}
function Le(e, t, n) {
  be(e) === 2 ? e.set(t, n) : e[t] = n;
}
function Ye(e, t) {
  const n = $(e);
  return (n ? Q(n) : e)[t];
}
function le(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function it(e) {
  if (e)
    for (; e.finalities.revoke.length > 0; )
      e.finalities.revoke.pop()();
}
function _e(e, t) {
  return t ? e : [""].concat(e).map((n) => {
    const s = `${n}`;
    return s.indexOf("/") === -1 && s.indexOf("~") === -1 ? s : s.replace(/~/g, "~0").replace(/\//g, "~1");
  }).join("/");
}
function xn(e, t) {
  for (let n = 0; n < t.length - 1; n += 1) {
    const s = t[n];
    if (e = pe(be(e) === 3 ? Array.from(e) : e, s), typeof e != "object")
      throw new Error(`Cannot resolve patch at '${t.join("/")}'.`);
  }
  return e;
}
function Ln(e) {
  const t = Object.create(Object.getPrototypeOf(e));
  return Reflect.ownKeys(e).forEach((n) => {
    let s = Reflect.getOwnPropertyDescriptor(e, n);
    if (s.enumerable && s.configurable && s.writable) {
      t[n] = e[n];
      return;
    }
    s.writable || (s.writable = !0, s.configurable = !0), (s.get || s.set) && (s = {
      configurable: !0,
      writable: !0,
      enumerable: s.enumerable,
      value: e[n]
    }), Reflect.defineProperty(t, n, s);
  }), t;
}
const Pn = Object.prototype.propertyIsEnumerable;
function Kt(e, t) {
  let n;
  if (Array.isArray(e))
    return Array.prototype.concat.call(e);
  if (e instanceof Set)
    return new Set(e.values());
  if (e instanceof Map)
    return new Map(e);
  if (t != null && t.mark && (n = t.mark(e, Y), n !== void 0) && n !== Y.mutable) {
    if (n === Y.immutable)
      return Ln(e);
    if (typeof n == "function") {
      if (t.enablePatches || t.enableAutoFreeze)
        throw new Error("You can't use mark and patches or auto freeze together.");
      return n();
    }
    throw new Error(`Unsupported mark result: ${n}`);
  } else if (typeof e == "object" && Object.getPrototypeOf(e) === Object.prototype) {
    const s = {};
    return Object.keys(e).forEach((i) => {
      s[i] = e[i];
    }), Object.getOwnPropertySymbols(e).forEach((i) => {
      Pn.call(e, i) && (s[i] = e[i]);
    }), s;
  } else
    throw new Error("Please check mark() to ensure that it is a stable marker draftable function.");
}
function K(e) {
  e.copy || (e.copy = Kt(e.original, e.options));
}
function Se(e) {
  if (!ee(e))
    return yt(e);
  if (Array.isArray(e))
    return e.map(Se);
  if (e instanceof Map)
    return new Map(Array.from(e.entries()).map(([n, s]) => [n, Se(s)]));
  if (e instanceof Set)
    return new Set(Array.from(e).map(Se));
  const t = Object.create(Object.getPrototypeOf(e));
  for (const n in e)
    t[n] = Se(e[n]);
  return t;
}
function Be(e) {
  return ge(e) ? Se(e) : e;
}
function oe(e) {
  var t;
  e.assignedMap = (t = e.assignedMap) !== null && t !== void 0 ? t : /* @__PURE__ */ new Map(), e.operated || (e.operated = !0, e.parent && oe(e.parent));
}
function Pt() {
  throw new Error("Cannot modify frozen object");
}
function we(e, t, n, s, i) {
  {
    n = n ?? /* @__PURE__ */ new WeakMap(), s = s ?? [], i = i ?? [];
    const r = n.has(e) ? n.get(e) : e;
    if (s.length > 0) {
      const a = s.indexOf(r);
      if (r && typeof r == "object" && a !== -1)
        throw s[0] === r ? new Error("Forbids circular reference") : new Error(`Forbids circular reference: ~/${i.slice(0, a).map((u, f) => {
          if (typeof u == "symbol")
            return `[${u.toString()}]`;
          const c = s[f];
          return typeof u == "object" && (c instanceof Map || c instanceof Set) ? Array.from(c.keys()).indexOf(u) : u;
        }).join("/")}`);
      s.push(r), i.push(t);
    } else
      s.push(r);
  }
  if (Object.isFrozen(e) || ge(e)) {
    s.pop(), i.pop();
    return;
  }
  switch (be(e)) {
    case 2:
      for (const [a, u] of e)
        we(a, a, n, s, i), we(u, a, n, s, i);
      e.set = e.clear = e.delete = Pt;
      break;
    case 3:
      for (const a of e)
        we(a, a, n, s, i);
      e.add = e.clear = e.delete = Pt;
      break;
    case 1:
      Object.freeze(e);
      let r = 0;
      for (const a of e)
        we(a, r, n, s, i), r += 1;
      break;
    default:
      Object.freeze(e), Object.keys(e).forEach((a) => {
        const u = e[a];
        we(u, a, n, s, i);
      });
  }
  s.pop(), i.pop();
}
function _t(e, t) {
  const n = be(e);
  if (n === 0)
    Reflect.ownKeys(e).forEach((s) => {
      t(s, e[s], e);
    });
  else if (n === 1) {
    let s = 0;
    for (const i of e)
      t(s, i, e), s += 1;
  } else
    e.forEach((s, i) => t(i, s, e));
}
function Xt(e, t, n) {
  if (ge(e) || !ee(e, n) || t.has(e) || Object.isFrozen(e))
    return;
  const s = e instanceof Set, i = s ? /* @__PURE__ */ new Map() : void 0;
  if (t.add(e), _t(e, (o, r) => {
    var a;
    if (ge(r)) {
      const u = $(r);
      K(u);
      const f = !((a = u.assignedMap) === null || a === void 0) && a.size || u.operated ? u.copy : u.original;
      Le(s ? i : e, o, f);
    } else
      Xt(r, t, n);
  }), i) {
    const o = e, r = Array.from(o);
    o.clear(), r.forEach((a) => {
      o.add(i.has(a) ? i.get(a) : a);
    });
  }
}
function Tn(e, t) {
  const n = e.type === 3 ? e.setMap : e.copy;
  e.finalities.revoke.length > 1 && e.assignedMap.get(t) && n && Xt(pe(n, t), e.finalities.handledSet, e.options);
}
function rt(e) {
  e.type === 3 && e.copy && (e.copy.clear(), e.setMap.forEach((t) => {
    e.copy.add(yt(t));
  }));
}
function ot(e, t, n, s) {
  if (e.operated && e.assignedMap && e.assignedMap.size > 0 && !e.finalized) {
    if (n && s) {
      const o = Wt(e);
      o && t(e, o, n, s);
    }
    e.finalized = !0;
  }
}
function gt(e, t, n, s) {
  const i = $(n);
  i && (i.callbacks || (i.callbacks = []), i.callbacks.push((o, r) => {
    var a;
    const u = e.type === 3 ? e.setMap : e.copy;
    if (le(pe(u, t), n)) {
      let f = i.original;
      i.copy && (f = i.copy), rt(e), ot(e, s, o, r), e.options.enableAutoFreeze && (e.options.updatedValues = (a = e.options.updatedValues) !== null && a !== void 0 ? a : /* @__PURE__ */ new WeakMap(), e.options.updatedValues.set(f, i.original)), Le(u, t, f);
    }
  }), e.options.enableAutoFreeze && i.finalities !== e.finalities && (e.options.enableAutoFreeze = !1)), ee(n, e.options) && e.finalities.draft.push(() => {
    const o = e.type === 3 ? e.setMap : e.copy;
    le(pe(o, t), n) && Tn(e, t);
  });
}
function Dn(e, t, n, s, i) {
  let { original: o, assignedMap: r, options: a } = e, u = e.copy;
  u.length < o.length && ([o, u] = [u, o], [n, s] = [s, n]);
  for (let f = 0; f < o.length; f += 1)
    if (r.get(f.toString()) && u[f] !== o[f]) {
      const c = t.concat([f]), d = _e(c, i);
      n.push({
        op: B.Replace,
        path: d,
        // If it is a draft, it needs to be deep cloned, and it may also be non-draft.
        value: Be(u[f])
      }), s.push({
        op: B.Replace,
        path: d,
        // If it is a draft, it needs to be deep cloned, and it may also be non-draft.
        value: Be(o[f])
      });
    }
  for (let f = o.length; f < u.length; f += 1) {
    const c = t.concat([f]), d = _e(c, i);
    n.push({
      op: B.Add,
      path: d,
      // If it is a draft, it needs to be deep cloned, and it may also be non-draft.
      value: Be(u[f])
    });
  }
  if (o.length < u.length) {
    const { arrayLengthAssignment: f = !0 } = a.enablePatches;
    if (f) {
      const c = t.concat(["length"]), d = _e(c, i);
      s.push({
        op: B.Replace,
        path: d,
        value: o.length
      });
    } else
      for (let c = u.length; o.length < c; c -= 1) {
        const d = t.concat([c - 1]), y = _e(d, i);
        s.push({
          op: B.Remove,
          path: y
        });
      }
  }
}
function Hn({ original: e, copy: t, assignedMap: n }, s, i, o, r) {
  n.forEach((a, u) => {
    const f = pe(e, u), c = Be(pe(t, u)), d = a ? Ie(e, u) ? B.Replace : B.Add : B.Remove;
    if (le(f, c) && d === B.Replace)
      return;
    const y = s.concat(u), w = _e(y, r);
    i.push(d === B.Remove ? { op: d, path: w } : { op: d, path: w, value: c }), o.push(d === B.Add ? { op: B.Remove, path: w } : d === B.Remove ? { op: B.Add, path: w, value: f } : { op: B.Replace, path: w, value: f });
  });
}
function kn({ original: e, copy: t }, n, s, i, o) {
  let r = 0;
  e.forEach((a) => {
    if (!t.has(a)) {
      const u = n.concat([r]), f = _e(u, o);
      s.push({
        op: B.Remove,
        path: f,
        value: a
      }), i.unshift({
        op: B.Add,
        path: f,
        value: a
      });
    }
    r += 1;
  }), r = 0, t.forEach((a) => {
    if (!e.has(a)) {
      const u = n.concat([r]), f = _e(u, o);
      s.push({
        op: B.Add,
        path: f,
        value: a
      }), i.unshift({
        op: B.Remove,
        path: f,
        value: a
      });
    }
    r += 1;
  });
}
function $e(e, t, n, s) {
  const { pathAsArray: i = !0 } = e.options.enablePatches;
  switch (e.type) {
    case 0:
    case 2:
      return Hn(e, t, n, s, i);
    case 1:
      return Dn(e, t, n, s, i);
    case 3:
      return kn(e, t, n, s, i);
  }
}
let Nn = !1;
const Fe = (e, t, n = !1) => {
  if (typeof e == "object" && e !== null && (!ee(e, t) || n) && !Nn)
    throw new Error("Strict mode: Mutable data cannot be accessed directly, please use 'unsafe(callback)' wrap.");
}, at = {
  get size() {
    return Q($(this)).size;
  },
  has(e) {
    return Q($(this)).has(e);
  },
  set(e, t) {
    const n = $(this), s = Q(n);
    return (!s.has(e) || !le(s.get(e), t)) && (K(n), oe(n), n.assignedMap.set(e, !0), n.copy.set(e, t), gt(n, e, t, $e)), this;
  },
  delete(e) {
    if (!this.has(e))
      return !1;
    const t = $(this);
    return K(t), oe(t), t.original.has(e) ? t.assignedMap.set(e, !1) : t.assignedMap.delete(e), t.copy.delete(e), !0;
  },
  clear() {
    const e = $(this);
    if (this.size) {
      K(e), oe(e), e.assignedMap = /* @__PURE__ */ new Map();
      for (const [t] of e.original)
        e.assignedMap.set(t, !1);
      e.copy.clear();
    }
  },
  forEach(e, t) {
    const n = $(this);
    Q(n).forEach((s, i) => {
      e.call(t, this.get(i), i, this);
    });
  },
  get(e) {
    var t, n;
    const s = $(this), i = Q(s).get(e), o = ((n = (t = s.options).mark) === null || n === void 0 ? void 0 : n.call(t, i, Y)) === Y.mutable;
    if (s.options.strict && Fe(i, s.options, o), o || s.finalized || !ee(i, s.options) || i !== s.original.get(e))
      return i;
    const r = mt.createDraft({
      original: i,
      parentDraft: s,
      key: e,
      finalities: s.finalities,
      options: s.options
    });
    return K(s), s.copy.set(e, r), r;
  },
  keys() {
    return Q($(this)).keys();
  },
  values() {
    const e = this.keys();
    return {
      [Ue]: () => this.values(),
      next: () => {
        const t = e.next();
        return t.done ? t : {
          done: !1,
          value: this.get(t.value)
        };
      }
    };
  },
  entries() {
    const e = this.keys();
    return {
      [Ue]: () => this.entries(),
      next: () => {
        const t = e.next();
        if (t.done)
          return t;
        const n = this.get(t.value);
        return {
          done: !1,
          value: [t.value, n]
        };
      }
    };
  },
  [Ue]() {
    return this.entries();
  }
}, jn = Reflect.ownKeys(at), Tt = (e, t, { isValuesIterator: n }) => () => {
  var s, i;
  const o = t.next();
  if (o.done)
    return o;
  const r = o.value;
  let a = e.setMap.get(r);
  const u = $(a), f = ((i = (s = e.options).mark) === null || i === void 0 ? void 0 : i.call(s, a, Y)) === Y.mutable;
  if (e.options.strict && Fe(r, e.options, f), !f && !u && ee(r, e.options) && !e.finalized && e.original.has(r)) {
    const c = mt.createDraft({
      original: r,
      parentDraft: e,
      key: r,
      finalities: e.finalities,
      options: e.options
    });
    e.setMap.set(r, c), a = c;
  } else
    u && (a = u.proxy);
  return {
    done: !1,
    value: n ? a : [a, a]
  };
}, ut = {
  get size() {
    return $(this).setMap.size;
  },
  has(e) {
    const t = $(this);
    if (t.setMap.has(e))
      return !0;
    K(t);
    const n = $(e);
    return !!(n && t.setMap.has(n.original));
  },
  add(e) {
    const t = $(this);
    return this.has(e) || (K(t), oe(t), t.assignedMap.set(e, !0), t.setMap.set(e, e), gt(t, e, e, $e)), this;
  },
  delete(e) {
    if (!this.has(e))
      return !1;
    const t = $(this);
    K(t), oe(t);
    const n = $(e);
    return n && t.setMap.has(n.original) ? (t.assignedMap.set(n.original, !1), t.setMap.delete(n.original)) : (!n && t.setMap.has(e) ? t.assignedMap.set(e, !1) : t.assignedMap.delete(e), t.setMap.delete(e));
  },
  clear() {
    if (!this.size)
      return;
    const e = $(this);
    K(e), oe(e);
    for (const t of e.original)
      e.assignedMap.set(t, !1);
    e.setMap.clear();
  },
  values() {
    const e = $(this);
    K(e);
    const t = e.setMap.keys();
    return {
      [Symbol.iterator]: () => this.values(),
      next: Tt(e, t, { isValuesIterator: !0 })
    };
  },
  entries() {
    const e = $(this);
    K(e);
    const t = e.setMap.keys();
    return {
      [Symbol.iterator]: () => this.entries(),
      next: Tt(e, t, {
        isValuesIterator: !1
      })
    };
  },
  keys() {
    return this.values();
  },
  [Ue]() {
    return this.values();
  },
  forEach(e, t) {
    const n = this.values();
    let s = n.next();
    for (; !s.done; )
      e.call(t, s.value, s.value, this), s = n.next();
  }
}, Un = Reflect.ownKeys(ut), qt = /* @__PURE__ */ new WeakSet(), Qt = {
  get(e, t, n) {
    var s, i;
    const o = (s = e.copy) === null || s === void 0 ? void 0 : s[t];
    if (o && qt.has(o))
      return o;
    if (t === Jt)
      return e;
    let r;
    if (e.options.mark) {
      const f = t === "size" && (e.original instanceof Map || e.original instanceof Set) ? Reflect.get(e.original, t) : Reflect.get(e.original, t, n);
      if (r = e.options.mark(f, Y), r === Y.mutable)
        return e.options.strict && Fe(f, e.options, !0), f;
    }
    const a = Q(e);
    if (a instanceof Map && jn.includes(t)) {
      if (t === "size")
        return Object.getOwnPropertyDescriptor(at, "size").get.call(e.proxy);
      const f = at[t];
      if (f)
        return f.bind(e.proxy);
    }
    if (a instanceof Set && Un.includes(t)) {
      if (t === "size")
        return Object.getOwnPropertyDescriptor(ut, "size").get.call(e.proxy);
      const f = ut[t];
      if (f)
        return f.bind(e.proxy);
    }
    if (!Ie(a, t)) {
      const f = Lt(a, t);
      return f ? "value" in f ? f.value : (
        // !case: support for getter
        (i = f.get) === null || i === void 0 ? void 0 : i.call(e.proxy)
      ) : void 0;
    }
    const u = a[t];
    if (e.options.strict && Fe(u, e.options), e.finalized || !ee(u, e.options))
      return u;
    if (u === Ye(e.original, t)) {
      if (K(e), e.copy[t] = bt({
        original: e.original[t],
        parentDraft: e,
        key: e.type === 1 ? Number(t) : t,
        finalities: e.finalities,
        options: e.options
      }), typeof r == "function") {
        const f = $(e.copy[t]);
        return K(f), oe(f), f.copy;
      }
      return e.copy[t];
    }
    return u;
  },
  set(e, t, n) {
    var s;
    if (e.type === 3 || e.type === 2)
      throw new Error("Map/Set draft does not support any property assignment.");
    let i;
    if (e.type === 1 && t !== "length" && !(Number.isInteger(i = Number(t)) && i >= 0 && (t === 0 || i === 0 || String(i) === String(t))))
      throw new Error("Only supports setting array indices and the 'length' property.");
    const o = Lt(Q(e), t);
    if (o != null && o.set)
      return o.set.call(e.proxy, n), !0;
    const r = Ye(Q(e), t), a = $(r);
    return a && le(a.original, n) ? (e.copy[t] = n, e.assignedMap = (s = e.assignedMap) !== null && s !== void 0 ? s : /* @__PURE__ */ new Map(), e.assignedMap.set(t, !1), !0) : (le(n, r) && (n !== void 0 || Ie(e.original, t)) || (K(e), oe(e), Ie(e.original, t) && le(n, e.original[t]) ? e.assignedMap.delete(t) : e.assignedMap.set(t, !0), e.copy[t] = n, gt(e, t, n, $e)), !0);
  },
  has(e, t) {
    return t in Q(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(Q(e));
  },
  getOwnPropertyDescriptor(e, t) {
    const n = Q(e), s = Reflect.getOwnPropertyDescriptor(n, t);
    return s && {
      writable: !0,
      configurable: e.type !== 1 || t !== "length",
      enumerable: s.enumerable,
      value: n[t]
    };
  },
  getPrototypeOf(e) {
    return Reflect.getPrototypeOf(e.original);
  },
  setPrototypeOf() {
    throw new Error("Cannot call 'setPrototypeOf()' on drafts");
  },
  defineProperty() {
    throw new Error("Cannot call 'defineProperty()' on drafts");
  },
  deleteProperty(e, t) {
    var n;
    return e.type === 1 ? Qt.set.call(this, e, t, void 0, e.proxy) : (Ye(e.original, t) !== void 0 || t in e.original ? (K(e), oe(e), e.assignedMap.set(t, !1)) : (e.assignedMap = (n = e.assignedMap) !== null && n !== void 0 ? n : /* @__PURE__ */ new Map(), e.assignedMap.delete(t)), e.copy && delete e.copy[t], !0);
  }
};
function bt(e) {
  const { original: t, parentDraft: n, key: s, finalities: i, options: o } = e, r = be(t), a = {
    type: r,
    finalized: !1,
    parent: n,
    original: t,
    copy: null,
    proxy: null,
    finalities: i,
    options: o,
    // Mapping of draft Set items to their corresponding draft values.
    setMap: r === 3 ? new Map(t.entries()) : void 0
  };
  (s || "key" in e) && (a.key = s);
  const { proxy: u, revoke: f } = Proxy.revocable(r === 1 ? Object.assign([], a) : a, Qt);
  if (i.revoke.push(f), qt.add(u), a.proxy = u, n) {
    const c = n;
    c.finalities.draft.push((d, y) => {
      var w, _;
      const S = $(u);
      let v = c.type === 3 ? c.setMap : c.copy;
      const x = pe(v, s), b = $(x);
      if (b) {
        let A = b.original;
        b.operated && (A = yt(x)), rt(b), ot(b, $e, d, y), c.options.enableAutoFreeze && (c.options.updatedValues = (w = c.options.updatedValues) !== null && w !== void 0 ? w : /* @__PURE__ */ new WeakMap(), c.options.updatedValues.set(A, b.original)), Le(v, s, A);
      }
      (_ = S.callbacks) === null || _ === void 0 || _.forEach((A) => {
        A(d, y);
      });
    });
  } else {
    const c = $(u);
    c.finalities.draft.push((d, y) => {
      rt(c), ot(c, $e, d, y);
    });
  }
  return u;
}
mt.createDraft = bt;
function Bn(e, t, n, s, i) {
  var o;
  const r = $(e), a = (o = r == null ? void 0 : r.original) !== null && o !== void 0 ? o : e, u = !!t.length;
  if (r != null && r.operated)
    for (; r.finalities.draft.length > 0; )
      r.finalities.draft.pop()(n, s);
  const f = u ? t[0] : r ? r.operated ? r.copy : r.original : e;
  return r && it(r), i && we(f, f, r == null ? void 0 : r.options.updatedValues), [
    f,
    n && u ? [{ op: B.Replace, path: [], value: t[0] }] : n,
    s && u ? [{ op: B.Replace, path: [], value: a }] : s
  ];
}
function Fn(e, t) {
  var n;
  const s = {
    draft: [],
    revoke: [],
    handledSet: /* @__PURE__ */ new WeakSet()
  };
  let i, o;
  t.enablePatches && (i = [], o = []);
  const a = ((n = t.mark) === null || n === void 0 ? void 0 : n.call(t, e, Y)) === Y.mutable || !ee(e, t) ? e : bt({
    original: e,
    parentDraft: null,
    finalities: s,
    options: t
  });
  return [
    a,
    (u = []) => {
      const [f, c, d] = Bn(a, u, i, o, t.enableAutoFreeze);
      return t.enablePatches ? [f, c, d] : f;
    }
  ];
}
function ct(e) {
  const { rootDraft: t, value: n, useRawReturn: s = !1, isRoot: i = !0 } = e;
  _t(n, (o, r, a) => {
    const u = $(r);
    if (u && t && u.finalities === t.finalities) {
      e.isContainDraft = !0;
      const f = u.original;
      if (a instanceof Set) {
        const c = Array.from(a);
        a.clear(), c.forEach((d) => a.add(o === d ? f : d));
      } else
        Le(a, o, f);
    } else
      typeof r == "object" && r !== null && (e.value = r, e.isRoot = !1, ct(e));
  }), i && (e.isContainDraft || console.warn("The return value does not contain any draft, please use 'rawReturn()' to wrap the return value to improve performance."), s && console.warn("The return value contains drafts, please don't use 'rawReturn()' to wrap the return value."));
}
function Yt(e) {
  const t = $(e);
  if (!ee(e, t == null ? void 0 : t.options))
    return e;
  const n = be(e);
  if (t && !t.operated)
    return t.original;
  let s;
  function i() {
    s = n === 2 ? new Map(e) : n === 3 ? Array.from(t.setMap.values()) : Kt(e, t == null ? void 0 : t.options);
  }
  if (t) {
    t.finalized = !0;
    try {
      i();
    } finally {
      t.finalized = !1;
    }
  } else
    s = e;
  return _t(s, (o, r) => {
    if (t && le(pe(t.original, o), r))
      return;
    const a = Yt(r);
    a !== r && (s === e && i(), Le(s, o, a));
  }), n === 3 ? new Set(s) : s;
}
function Dt(e) {
  if (!ge(e))
    throw new Error(`current() is only used for Draft, parameter: ${e}`);
  return Yt(e);
}
const zn = (e) => {
  if (e !== void 0 && Object.prototype.toString.call(e) !== "[object Object]")
    throw new Error(`Invalid options: ${String(e)}, 'options' should be an object.`);
  return function t(n, s, i) {
    var o, r, a;
    if (typeof n == "function" && typeof s != "function")
      return function(R, ...D) {
        return t(R, (O) => n.call(this, O, ...D), s);
      };
    const u = n, f = s;
    let c = i;
    if (typeof s != "function" && (c = s), c !== void 0 && Object.prototype.toString.call(c) !== "[object Object]")
      throw new Error(`Invalid options: ${c}, 'options' should be an object.`);
    c = Object.assign(Object.assign({}, e), c);
    const d = ge(u) ? Dt(u) : u, y = Array.isArray(c.mark) ? (R, D) => {
      for (const O of c.mark) {
        if (typeof O != "function")
          throw new Error(`Invalid mark: ${O}, 'mark' should be a function.`);
        const L = O(R, D);
        if (L)
          return L;
      }
    } : c.mark, w = (o = c.enablePatches) !== null && o !== void 0 ? o : !1, _ = (r = c.strict) !== null && r !== void 0 ? r : !1, v = {
      enableAutoFreeze: (a = c.enableAutoFreeze) !== null && a !== void 0 ? a : !1,
      mark: y,
      strict: _,
      enablePatches: w
    };
    if (!ee(d, v) && typeof d == "object" && d !== null)
      throw new Error("Invalid base state: create() only supports plain objects, arrays, Set, Map or using mark() to mark the state as immutable.");
    const [x, b] = Fn(d, v);
    if (typeof s != "function") {
      if (!ee(d, v))
        throw new Error("Invalid base state: create() only supports plain objects, arrays, Set, Map or using mark() to mark the state as immutable.");
      return [x, b];
    }
    let A;
    try {
      A = f(x);
    } catch (R) {
      throw it($(x)), R;
    }
    const I = (R) => {
      const D = $(x);
      if (!ge(R)) {
        if (R !== void 0 && !le(R, x) && (D != null && D.operated))
          throw new Error("Either the value is returned as a new non-draft value, or only the draft is modified without returning any value.");
        const L = R == null ? void 0 : R[$n];
        if (L) {
          const z = L[0];
          return v.strict && typeof R == "object" && R !== null && ct({
            rootDraft: D,
            value: R,
            useRawReturn: !0
          }), b([z]);
        }
        if (R !== void 0)
          return typeof R == "object" && R !== null && ct({ rootDraft: D, value: R }), b([R]);
      }
      if (R === x || R === void 0)
        return b([]);
      const O = $(R);
      if (v === O.options) {
        if (O.operated)
          throw new Error("Cannot return a modified child draft.");
        return b([Dt(R)]);
      }
      return b([R]);
    };
    return A instanceof Promise ? A.then(I, (R) => {
      throw it($(x)), R;
    }) : I(A);
  };
}, E = zn();
Object.prototype.constructor.toString();
const Gn = dt(fetch), Zt = async (e, t) => {
  if (!e)
    throw "Metapage definition null";
  if (e.version || (e = E(e, (s) => {
    s.version = "0.3";
  })), !t)
    throw 'Missing "version" argument';
  if (V(t, Je) > 0)
    try {
      return await (await Gn(`https://module.metapage.io/conversion/metapage/${t}`, {
        redirect: "follow",
        retries: 3,
        retryDelay: 1e3,
        method: "POST",
        body: JSON.stringify(e),
        headers: {
          "Content-Type": "application/json"
        }
      })).json();
    } catch (s) {
      throw `Error converting metapage definition to version ${t}: ${s}`;
    }
  return Jn(e, t);
}, Vn = async (e) => Zt(e, Je), Jn = (e, t) => {
  if (!e)
    throw "Metapage definition null";
  if (!e.version)
    throw 'Missing "version" key in metapage definition';
  let n = Re(e.version);
  if (n === t)
    return e;
  let s = e;
  for (; n !== t; )
    switch (n) {
      case "0.2": {
        if (V(t, n) > 0)
          s = Wn(s), n = Re(s.version);
        else
          throw `Cannot convert from version ${n} to ${t}`;
        break;
      }
      case "0.3": {
        V(t, n) > 0 ? (s = Xn(s), n = Re(s.version)) : (s = Kn(s), n = Re(s.version));
        break;
      }
      case "1": {
        if (V(t, n) > 0)
          throw `Cannot convert from version ${n} to ${t}, 1 is the latest version`;
        s = qn(s), n = Re(s.version);
        break;
      }
      default:
        throw `Unknow version ${n} to ${t}`;
    }
  return s;
}, Wn = (e) => E(e, (t) => {
  t.version = "0.3";
}), Kn = (e) => E(e, (t) => {
  t.version = "0.2";
}), Xn = (e) => E(e, (t) => {
  const n = t;
  delete n.plugins, n.version = "1";
}), qn = (e) => E(e, (t) => (t.version = "0.3", t)), Re = (e) => {
  if (e === "latest")
    return Je;
  if (V(e, "0.2") < 0)
    throw `Unknown version: ${e}`;
  if (V(e, "0.2") <= 0 && V(e, "0.3") < 0)
    return "0.2";
  if (V(e, "0.3") <= 0)
    return "0.3";
  if (e === "1")
    return "1";
  throw `Unknown version: ${e}`;
}, Qn = dt(fetch), en = async (e, t) => {
  if (!e)
    throw "Metapage definition null";
  if (!e.version)
    throw 'Missing "version" key in metapage definition';
  if (!t)
    throw 'Missing "version" argument';
  if (V(t, pt) > 0)
    try {
      return await (await Qn(`https://module.metapage.io/conversion/metaframe/${t}`, {
        redirect: "follow",
        retries: 3,
        retryDelay: 1e3,
        method: "POST",
        body: JSON.stringify(e),
        headers: {
          "Content-Type": "application/json"
        }
      })).json();
    } catch (s) {
      throw `Error converting metapage definition to version ${t}: ${s}`;
    }
  return Zn(e, t);
}, Yn = async (e) => en(e, pt), Zn = (e, t) => {
  if (!e)
    throw "Metaframe definition null";
  e.version || (e = E(e, (i) => {
    i.version = "0.3";
  }));
  let n = ue(e.version);
  if (n === t)
    return e;
  let s = e;
  for (; n !== t; )
    switch (n) {
      case "0.3": {
        if (V(t, n) > 0)
          s = ns(s), n = ue(s.version);
        else
          throw `Cannot convert from version ${n} to ${t}`;
        break;
      }
      case "0.4": {
        V(t, n) > 0 ? (s = ss(s), n = ue(s.version)) : (s = ts(s), n = ue(s.version));
        break;
      }
      case "0.5": {
        V(t, n) > 0 ? (s = as(s), n = ue(s.version)) : (s = is(s), n = ue(s.version));
        break;
      }
      case "0.6": {
        V(t, n) > 0 ? (s = rs(s), n = ue(s.version)) : (s = us(s), n = ue(s.version));
        break;
      }
      case "1": {
        if (V(t, n) > 0)
          throw `Cannot convert from version ${n} to ${t}, 1 is the latest version`;
        s = os(s), n = ue(s.version);
        break;
      }
      default:
        throw `Unknow version ${n} to ${t}`;
    }
  return s;
}, es = async (e, t) => {
  if (e)
    return Yn(e);
}, ts = (e) => E(e, (t) => {
  t.version = "0.3", delete t.allow;
}), ns = (e) => E(e, (t) => {
  t.version = "0.4";
}), ss = (e) => E(e, (t) => {
  if (t.version = "0.5", !(t != null && t.metadata))
    return;
  const n = t.metadata.title;
  delete t.metadata.title, t.metadata.name = n;
  const s = t.metadata.descriptionUrl;
  delete t.metadata.descriptionUrl, t.metadata.description = s;
  const i = t.metadata.keywords;
  delete t.metadata.keywords, t.metadata.tags = i;
}), is = (e) => E(e, (t) => {
  if (t.version = "0.4", !(t != null && t.metadata))
    return;
  const n = t.metadata.name;
  delete t.metadata.name, t.metadata.title = n;
  const s = t.metadata.description;
  delete t.metadata.description, t.metadata.descriptionUrl = s;
  const i = t.metadata.tags;
  delete t.metadata.tags, t.metadata.keywords = i;
}), rs = (e) => E(e, (t) => {
  var n;
  t.version = "1", (n = t == null ? void 0 : t.metadata) != null && n.operations && delete t.metadata.operations;
}), os = (e) => E(e, (t) => {
  var n;
  t.version = "0.6", (n = t == null ? void 0 : t.metadata) != null && n.operations && delete t.metadata.operations;
}), as = (e) => E(e, (t) => {
  var n;
  t.version = "0.6", (n = t == null ? void 0 : t.metadata) != null && n.operations && delete t.metadata.operations;
}), us = (e) => E(e, (t) => {
  var n;
  t.version = "0.5", (n = t == null ? void 0 : t.metadata) != null && n.operations && delete t.metadata.operations;
}), ue = (e) => {
  if (e === "latest")
    return pt;
  if (V(e, "0.3") < 0)
    throw `Unknown version: ${e}`;
  if (V(e, "0.3") <= 0)
    return "0.3";
  if (V(e, "0.4") <= 0)
    return "0.4";
  if (V(e, "0.5") <= 0)
    return "0.5";
  if (V(e, "0.6") <= 0)
    return "0.6";
  if (e === "1")
    return "1";
  throw `Unknown version: ${e}`;
};
var Oe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Ee = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Ne = 0; Ne < Oe.length; Ne++)
  Ee[Oe.charCodeAt(Ne)] = Ne;
var je = function(e) {
  var t = new Uint8Array(e), n, s = t.length, i = "";
  for (n = 0; n < s; n += 3)
    i += Oe[t[n] >> 2], i += Oe[(t[n] & 3) << 4 | t[n + 1] >> 4], i += Oe[(t[n + 1] & 15) << 2 | t[n + 2] >> 6], i += Oe[t[n + 2] & 63];
  return s % 3 === 2 ? i = i.substring(0, i.length - 1) + "=" : s % 3 === 1 && (i = i.substring(0, i.length - 2) + "=="), i;
}, de = function(e) {
  var t = e.length * 0.75, n = e.length, s, i = 0, o, r, a, u;
  e[e.length - 1] === "=" && (t--, e[e.length - 2] === "=" && t--);
  var f = new ArrayBuffer(t), c = new Uint8Array(f);
  for (s = 0; s < n; s += 4)
    o = Ee[e.charCodeAt(s)], r = Ee[e.charCodeAt(s + 1)], a = Ee[e.charCodeAt(s + 2)], u = Ee[e.charCodeAt(s + 3)], c[i++] = o << 2 | r >> 4, c[i++] = (r & 15) << 4 | a >> 2, c[i++] = (a & 3) << 6 | u & 63;
  return f;
};
const We = async (e) => E(e, async (t) => {
  for (const n of Object.keys(e)) {
    const s = await cs(e[n]);
    return t[n] = s, t;
  }
}), Ce = async (e) => E(e, async (t) => {
  for (const n of Object.keys(e)) {
    const s = await tn(e[n]);
    return t[n] = s, t;
  }
}), wi = async (e, t, n) => {
  if (e = tn(e), n = n || {}, n.type || (n.type = "application/octet-stream"), e instanceof ArrayBuffer)
    return new File([e], t, n);
  if (e instanceof File || e instanceof Blob) {
    const i = await e.arrayBuffer();
    return e instanceof File && (n.type = e.type), new File([i], t, n);
  }
  if (e instanceof Int8Array || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Int16Array || e instanceof Uint16Array || e instanceof Int32Array || e instanceof Uint32Array || e instanceof Float32Array || e instanceof Float64Array) {
    const i = e;
    return new File([i.buffer], t, n);
  }
  if (typeof e == "string") {
    var s = new Blob([e], { type: "text/plain" });
    return n.type = "text/plain", new File([s], t, n);
  }
  if (typeof e == "object") {
    const i = new Blob([JSON.stringify(e)], {
      type: "application/json"
    });
    return n.type = "application/json", new File([i], t, n);
  }
  var s = new Blob([e], { type: "text/plain" });
  return n.type = "text/plain", new File([s], t, n);
}, cs = async (e) => {
  if (e instanceof Int8Array || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Int16Array || e instanceof Uint16Array || e instanceof Int32Array || e instanceof Uint32Array || e instanceof Float32Array || e instanceof Float64Array) {
    const t = e, n = {
      _s: !0,
      _c: e.constructor.name,
      value: je(t.buffer),
      byteLength: t.byteLength,
      byteOffset: t.byteOffset,
      size: t.byteLength
    };
    return Promise.resolve(n);
  } else if (e instanceof File) {
    const t = e, n = await t.arrayBuffer();
    return {
      _s: !0,
      _c: File.name,
      value: je(n),
      name: t.name,
      fileType: t.type,
      lastModified: t.lastModified,
      size: n.byteLength
    };
  } else if (e instanceof Blob) {
    const t = e, n = await t.arrayBuffer();
    return {
      _s: !0,
      _c: Blob.name,
      value: je(n),
      fileType: t.type,
      size: n.byteLength
    };
  } else if (e instanceof ArrayBuffer) {
    const t = e, n = {
      _s: !0,
      _c: ArrayBuffer.name,
      value: je(t),
      size: t.byteLength
    };
    return Promise.resolve(n);
  }
  return Promise.resolve(e);
}, tn = (e) => {
  if (!(e && typeof e == "object" && e._s === !0))
    return e;
  const t = e, n = t._c;
  if (n === Blob.name) {
    const r = e;
    return new Blob([de(t.value)], {
      type: r.fileType
    });
  } else if (n === File.name) {
    const r = e;
    return new File([de(t.value)], r.name, {
      type: r.fileType,
      lastModified: r.lastModified
    });
  } else if (n === ArrayBuffer.name)
    return de(t.value);
  const s = e, i = de(s.value), o = s._c;
  try {
    return new globalThis[o](i);
  } catch {
  }
  return e;
}, Ri = (e) => {
  if (!(e && typeof e == "object" && e._s === !0))
    return;
  const t = e, n = t._c;
  if (n === Blob.name) {
    const r = e, a = new Blob([de(t.value)], {
      type: r.fileType
    });
    return new File([a], "file", {
      type: a.type
    });
  } else if (n === File.name) {
    const r = e;
    return new File([de(t.value)], r.name, {
      type: r.fileType,
      lastModified: r.lastModified
    });
  } else if (n === ArrayBuffer.name) {
    const r = de(t.value);
    return new File([r], "file", {
      type: "application/octet-stream"
    });
  }
  const s = e, i = de(s.value), o = s._c;
  try {
    const r = new globalThis[o](i);
    return new File([r], "file", {
      type: "application/octet-stream"
    });
  } catch {
  }
};
var M;
(function(e) {
  e.Inputs = "inputs", e.Outputs = "outputs", e.State = "state", e.Definition = "definition", e.Error = "error", e.Warning = "warning", e.UrlHashUpdate = "urlhashupdate", e.Message = "Message";
})(M || (M = {}));
var X;
(function(e) {
  e.InputsUpdate = "InputsUpdate", e.OutputsUpdate = "OutputsUpdate", e.SetupIframeClientRequest = "SetupIframeClientRequest", e.SetupIframeServerResponseAck = "SetupIframeServerResponseAck", e.HashParamsUpdate = "HashParamsUpdate";
})(X || (X = {}));
var fe;
(function(e) {
  e.InputsUpdate = "InputsUpdate", e.MessageAck = "MessageAck", e.SetupIframeServerResponse = "SetupIframeServerResponse";
})(fe || (fe = {}));
const Oi = -32700, Ai = -32600, Si = -32601, Ei = -32602, Mi = -32603;
function Ii(e) {
  switch (typeof e) {
    case "string":
      return !0;
    case "number":
      return e % 1 != 0;
    case "object":
      return e === null ? (console.warn("Use of null ID in JSONRPC 2.0 is discouraged."), !0) : !1;
    default:
      return !1;
  }
}
var nn = { exports: {} };
(function(e) {
  var t = Object.prototype.hasOwnProperty, n = "~";
  function s() {
  }
  Object.create && (s.prototype = /* @__PURE__ */ Object.create(null), new s().__proto__ || (n = !1));
  function i(u, f, c) {
    this.fn = u, this.context = f, this.once = c || !1;
  }
  function o(u, f, c, d, y) {
    if (typeof c != "function")
      throw new TypeError("The listener must be a function");
    var w = new i(c, d || u, y), _ = n ? n + f : f;
    return u._events[_] ? u._events[_].fn ? u._events[_] = [u._events[_], w] : u._events[_].push(w) : (u._events[_] = w, u._eventsCount++), u;
  }
  function r(u, f) {
    --u._eventsCount === 0 ? u._events = new s() : delete u._events[f];
  }
  function a() {
    this._events = new s(), this._eventsCount = 0;
  }
  a.prototype.eventNames = function() {
    var f = [], c, d;
    if (this._eventsCount === 0)
      return f;
    for (d in c = this._events)
      t.call(c, d) && f.push(n ? d.slice(1) : d);
    return Object.getOwnPropertySymbols ? f.concat(Object.getOwnPropertySymbols(c)) : f;
  }, a.prototype.listeners = function(f) {
    var c = n ? n + f : f, d = this._events[c];
    if (!d)
      return [];
    if (d.fn)
      return [d.fn];
    for (var y = 0, w = d.length, _ = new Array(w); y < w; y++)
      _[y] = d[y].fn;
    return _;
  }, a.prototype.listenerCount = function(f) {
    var c = n ? n + f : f, d = this._events[c];
    return d ? d.fn ? 1 : d.length : 0;
  }, a.prototype.emit = function(f, c, d, y, w, _) {
    var S = n ? n + f : f;
    if (!this._events[S])
      return !1;
    var v = this._events[S], x = arguments.length, b, A;
    if (v.fn) {
      switch (v.once && this.removeListener(f, v.fn, void 0, !0), x) {
        case 1:
          return v.fn.call(v.context), !0;
        case 2:
          return v.fn.call(v.context, c), !0;
        case 3:
          return v.fn.call(v.context, c, d), !0;
        case 4:
          return v.fn.call(v.context, c, d, y), !0;
        case 5:
          return v.fn.call(v.context, c, d, y, w), !0;
        case 6:
          return v.fn.call(v.context, c, d, y, w, _), !0;
      }
      for (A = 1, b = new Array(x - 1); A < x; A++)
        b[A - 1] = arguments[A];
      v.fn.apply(v.context, b);
    } else {
      var I = v.length, R;
      for (A = 0; A < I; A++)
        switch (v[A].once && this.removeListener(f, v[A].fn, void 0, !0), x) {
          case 1:
            v[A].fn.call(v[A].context);
            break;
          case 2:
            v[A].fn.call(v[A].context, c);
            break;
          case 3:
            v[A].fn.call(v[A].context, c, d);
            break;
          case 4:
            v[A].fn.call(v[A].context, c, d, y);
            break;
          default:
            if (!b)
              for (R = 1, b = new Array(x - 1); R < x; R++)
                b[R - 1] = arguments[R];
            v[A].fn.apply(v[A].context, b);
        }
    }
    return !0;
  }, a.prototype.on = function(f, c, d) {
    return o(this, f, c, d, !1);
  }, a.prototype.once = function(f, c, d) {
    return o(this, f, c, d, !0);
  }, a.prototype.removeListener = function(f, c, d, y) {
    var w = n ? n + f : f;
    if (!this._events[w])
      return this;
    if (!c)
      return r(this, w), this;
    var _ = this._events[w];
    if (_.fn)
      _.fn === c && (!y || _.once) && (!d || _.context === d) && r(this, w);
    else {
      for (var S = 0, v = [], x = _.length; S < x; S++)
        (_[S].fn !== c || y && !_[S].once || d && _[S].context !== d) && v.push(_[S]);
      v.length ? this._events[w] = v.length === 1 ? v[0] : v : r(this, w);
    }
    return this;
  }, a.prototype.removeAllListeners = function(f) {
    var c;
    return f ? (c = n ? n + f : f, this._events[c] && r(this, c)) : (this._events = new s(), this._eventsCount = 0), this;
  }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = n, a.EventEmitter = a, e.exports = a;
})(nn);
var vt = nn.exports;
function fs(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ls = function(e, t) {
  t || (t = {}), typeof t == "function" && (t = { cmp: t });
  var n = typeof t.cycles == "boolean" ? t.cycles : !1, s = t.cmp && /* @__PURE__ */ function(o) {
    return function(r) {
      return function(a, u) {
        var f = { key: a, value: r[a] }, c = { key: u, value: r[u] };
        return o(f, c);
      };
    };
  }(t.cmp), i = [];
  return function o(r) {
    if (r && r.toJSON && typeof r.toJSON == "function" && (r = r.toJSON()), r !== void 0) {
      if (typeof r == "number")
        return isFinite(r) ? "" + r : "null";
      if (typeof r != "object")
        return JSON.stringify(r);
      var a, u;
      if (Array.isArray(r)) {
        for (u = "[", a = 0; a < r.length; a++)
          a && (u += ","), u += o(r[a]) || "null";
        return u + "]";
      }
      if (r === null)
        return "null";
      if (i.indexOf(r) !== -1) {
        if (n)
          return JSON.stringify("__cycle__");
        throw new TypeError("Converting circular structure to JSON");
      }
      var f = i.push(r) - 1, c = Object.keys(r).sort(s && s(r));
      for (u = "", a = 0; a < c.length; a++) {
        var d = c[a], y = o(r[d]);
        y && (u && (u += ","), u += JSON.stringify(d) + ":" + y);
      }
      return i.splice(f, 1), "{" + u + "}";
    }
  }(e);
};
const ps = /* @__PURE__ */ fs(ls), hs = (e) => sn(ps(e)), ds = (e) => {
  if (e && e.length > 0)
    return JSON.parse(rn(e));
}, sn = (e) => btoa(encodeURIComponent(e)), rn = (e) => decodeURIComponent(atob(e)), on = (e) => {
  const t = new URL(e);
  return an(t.hash);
}, an = (e) => {
  let t = e;
  for (; t.startsWith("#"); )
    t = t.substring(1);
  const n = t.indexOf("?");
  if (n === -1)
    return [t, {}];
  const s = t.substring(0, n);
  t = t.substring(n + 1);
  const i = {};
  return t.split("&").filter((o) => o.length > 0).map((o) => {
    const r = o.indexOf("=");
    if (r === -1)
      return [o, ""];
    const a = o.substring(0, r), u = o.substring(r + 1);
    return [a, u];
  }).forEach(([o, r]) => {
    i[o] = r;
  }), Object.keys(i).forEach((o) => {
    try {
      i[o] = decodeURI(i[o]);
    } catch {
      i[o] = i[o];
    }
  }), [s, i];
}, Pe = (e, t) => {
  const [n, s] = on(e);
  return s[t];
}, ms = (e) => ys()[1][e], ys = () => on(window.location.href), Ae = (e, t, n) => {
  const s = window.location.hash.startsWith("#") ? window.location.hash.substring(1) : window.location.hash, i = _s(s, e, t);
  i !== s && (n != null && n.modifyHistory ? window.location.hash = i : (window.history.replaceState(null, document.title, `${window.location.pathname}${window.location.search}${i.startsWith("#") ? "" : "#"}${i}`), window.dispatchEvent(new HashChangeEvent("hashchange"))));
}, _s = (e, t, n) => {
  const [s, i] = an(e);
  let o = !1;
  if (i.hasOwnProperty(t) && n === null || n === void 0 ? (delete i[t], o = !0) : i[t] !== n && (i[t] = n, o = !0), !o)
    return e;
  const r = Object.keys(i);
  r.sort();
  const a = r.map((u, f) => `${u}=${encodeURI(i[u])}`).join("&");
  return `${s}?${a}`;
}, un = (e, t) => {
  const n = Pe(e, t);
  if (n && n !== "")
    return ds(n);
}, gs = (e, t, n) => {
  const s = t ? hs(t) : void 0;
  Ae(e, s, n);
}, bs = (e) => un(window.location.href, e), vs = (e, t) => {
  const n = Pe(e, t);
  return n ? parseFloat(n) : void 0;
}, cn = (e, t, n) => {
  Ae(e, t != null ? t.toString() : void 0, n);
}, ws = (e) => vs(window.location.href, e), Rs = (e, t) => {
  const n = Pe(e, t);
  return n ? parseInt(n) : void 0;
}, Os = (e, t, n) => {
  cn(e, t, n);
}, As = (e) => Rs(window.location.href, e), Ss = (e, t) => Pe(e, t) === "true", Es = (e, t, n) => {
  Ae(e, t ? "true" : void 0, n);
}, Ms = (e) => Ss(window.location.href, e), Is = (e, t) => {
  const n = Pe(e, t);
  return n && n !== "" ? rn(n) : void 0;
}, Cs = (e, t, n) => {
  const s = t == null ? void 0 : sn(t);
  Ae(e, s, n);
}, $s = (e) => Is(window.location.href, e);
var xs = function(e, t) {
  t || (t = {}), typeof t == "function" && (t = { cmp: t });
  var n = typeof t.cycles == "boolean" ? t.cycles : !1, s = t.cmp && function(o) {
    return function(r) {
      return function(a, u) {
        var f = { key: a, value: r[a] }, c = { key: u, value: r[u] };
        return o(f, c);
      };
    };
  }(t.cmp), i = [];
  return function o(r) {
    if (r && r.toJSON && typeof r.toJSON == "function" && (r = r.toJSON()), r !== void 0) {
      if (typeof r == "number")
        return isFinite(r) ? "" + r : "null";
      if (typeof r != "object")
        return JSON.stringify(r);
      var a, u;
      if (Array.isArray(r)) {
        for (u = "[", a = 0; a < r.length; a++)
          a && (u += ","), u += o(r[a]) || "null";
        return u + "]";
      }
      if (r === null)
        return "null";
      if (i.indexOf(r) !== -1) {
        if (n)
          return JSON.stringify("__cycle__");
        throw new TypeError("Converting circular structure to JSON");
      }
      var f = i.push(r) - 1, c = Object.keys(r).sort(s && s(r));
      for (u = "", a = 0; a < c.length; a++) {
        var d = c[a], y = o(r[d]);
        y && (u && (u += ","), u += JSON.stringify(d) + ":" + y);
      }
      return i.splice(f, 1), "{" + u + "}";
    }
  }(e);
};
const fn = /* @__PURE__ */ ht(xs);
var xe;
(function(e) {
  e.mp_debug = "mp_debug";
})(xe || (xe = {}));
const Ls = () => {
  try {
    return window !== window.top;
  } catch {
    return !1;
  }
}, ln = {
  version: Je,
  metaframes: {}
};
class Ps extends vt.EventEmitter {
  constructor() {
    super(), this._definition = ln, this.getDefinition = this.getDefinition.bind(this);
  }
  error(t) {
    throw "Subclass should implement";
  }
  getDefinition() {
    return this._definition;
  }
}
const ze = (e, t) => t ? E(e, (n) => {
  Object.keys(t).forEach((s) => {
    t[s] === void 0 ? delete n[s] : n[s] = t[s];
  });
}) : e, Ci = (e) => window.location.search ? new URLSearchParams(window.location.search).get(e) : null, $i = () => new URLSearchParams(window.location.search).has(xe.mp_debug), ft = () => {
  const e = new URLSearchParams(window.location.search).get(xe.mp_debug);
  return e === "true" || e === "1";
}, xi = (e = 8) => wt(e), Ts = (e = 8) => wt(e), Li = (e = 8) => wt(e), Ht = "abcdefghijklmnopqrstuvwxyz0123456789", wt = (e = 8) => {
  for (var t = "", n = Ht.length, s = 0; s < e; s++)
    t += Ht.charAt(Math.floor(Math.random() * n));
  return t;
}, Rt = (e, t, n) => {
  t = t || "000", t && t.trim() == "" && (t = void 0);
  let s;
  if (typeof e == "string" ? s = e : typeof e == "number" ? s = e + "" : s = JSON.stringify(e, null, "  "), t && t.trim() != "") {
    var i = `color: #${t}`;
    n && (i = `${i}; background: #${n}`), s = `%c${s}`, window.console.log(s, i);
  } else
    window.console.log(s);
}, pn = (e) => Hs(Ds(e)), Ds = (e) => {
  var t = 0;
  for (let n = 0; n < e.length; n++)
    t = e.charCodeAt(n) + ((t << 5) - t);
  return t;
}, Hs = (e) => {
  var t = (e & 16777215).toString(16).toUpperCase();
  return "00000".substring(0, 6 - t.length) + t;
}, Ze = () => document.readyState == "complete" || document.readyState == "interactive", Ot = async () => Ze() ? Promise.resolve() : new Promise((e) => {
  if (Ze()) {
    e();
    return;
  }
  let t = !1;
  window.addEventListener("load", () => {
    t || (t = !0, e());
  }), setTimeout(() => {
    !t && Ze() && (t = !0, e());
  }, 200);
}), Pi = async (e) => {
  const t = fn(e);
  return await hn(t);
}, Ti = async (e) => {
  const t = fn({
    version: e.version,
    metaframes: e.metaframes
  });
  return await hn(t);
};
async function hn(e) {
  const n = new TextEncoder().encode(e), s = await crypto.subtle.digest("SHA-256", n);
  return btoa(String.fromCharCode(...new Uint8Array(s)));
}
var re;
(function(e) {
  e.WaitingForPageLoad = "WaitingForPageLoad", e.SentSetupIframeClientRequest = "SentSetupIframeClientRequest", e.Ready = "Ready";
})(re || (re = {}));
var U;
(function(e) {
  e.Connected = "connected", e.Error = "error", e.Input = "input", e.Inputs = "inputs", e.Message = "message";
})(U || (U = {}));
class te extends vt.EventEmitter {
  constructor(t) {
    if (super(), this._inputPipeValues = {}, this._outputPipeValues = {}, this._state = re.WaitingForPageLoad, this._messageSendCount = 0, this.debug = ft(), this.isInputOutputBlobSerialization = !0, this.id = window.name, this.debug = ft(), this._isIframe = Ls(), this.addListener = this.addListener.bind(this), this.dispose = this.dispose.bind(this), this.error = this.error.bind(this), this.getInput = this.getInput.bind(this), this.getInputs = this.getInputs.bind(this), this.log = this.log.bind(this), this.logInternal = this.logInternal.bind(this), this.onInput = this.onInput.bind(this), this.onInputs = this.onInputs.bind(this), this.onMessage = this.onMessage.bind(this), this.sendRpc = this.sendRpc.bind(this), this.setInput = this.setInput.bind(this), this.setInputs = this.setInputs.bind(this), this.setInternalInputsAndNotify = this.setInternalInputsAndNotify.bind(this), this.setOutput = this.setOutput.bind(this), this.setOutputs = this.setOutputs.bind(this), this.warn = this.warn.bind(this), this._resolveSetupIframeServerResponse = this._resolveSetupIframeServerResponse.bind(this), this.addListenerReturnDisposer = this.addListenerReturnDisposer.bind(this), this.connected = this.connected.bind(this), this.isConnected = this.isConnected.bind(this), this.disableNotifyOnHashUrlChange = this.disableNotifyOnHashUrlChange.bind(this), this._onHashUrlChange = this._onHashUrlChange.bind(this), this.setParameter = this.setParameter.bind(this), this.setParameterBoolean = this.setParameterBoolean.bind(this), this.setParameterJson = this.setParameterJson.bind(this), this.setParameterBase64 = this.setParameterBase64.bind(this), this.setParameterFloat = this.setParameterFloat.bind(this), this.setParameterInt = this.setParameterInt.bind(this), this.getParameter = this.getParameter.bind(this), this.getParameterBoolean = this.getParameterBoolean.bind(this), this.getParameterJson = this.getParameterJson.bind(this), this.getParameterBase64 = this.getParameterBase64.bind(this), this.getParameterFloat = this.getParameterFloat.bind(this), this.getParameterInt = this.getParameterInt.bind(this), this.deleteParameter = this.deleteParameter.bind(this), !this._isIframe) {
      this.log("Not an iframe, metaframe code disabled");
      return;
    }
    const n = this;
    Ot().then(() => {
      this.log("pageLoaded"), window.addEventListener("message", this.onMessage), n.sendRpc(X.SetupIframeClientRequest, {
        version: te.version
      }), n._state = re.SentSetupIframeClientRequest;
    }), t && t.disableHashChangeEvent || window.addEventListener("hashchange", this._onHashUrlChange);
  }
  _resolveSetupIframeServerResponse(t) {
    if (this._state === re.WaitingForPageLoad)
      throw "Got message but page has not finished loading, we should never get in this state";
    (async () => this._parentId ? this.log("Got JsonRpcMethods.SetupIframeServerResponse but already resolved") : (this._parentVersion = t.version, this.color = pn(this.id), this._parentId = t.parentId, this.log(`metapage[${this._parentId}](v${this._parentVersion ? this._parentVersion : "unknown"}) registered`), t.state && t.state.inputs && (this.isInputOutputBlobSerialization ? this._inputPipeValues = await Ce(t.state.inputs) : this._inputPipeValues = t.state.inputs), this._state = re.Ready, this.sendRpc(X.SetupIframeServerResponseAck, {
      version: te.version
    }), this._inputPipeValues && Object.keys(this._inputPipeValues).length > 0 && (this.emit(U.Inputs, this._inputPipeValues), this.listenerCount(U.Input) > 0 && Object.keys(this._inputPipeValues).forEach((n) => this.emit(U.Input, n, this._inputPipeValues[n]))), this.emit(U.Connected), this.sendRpc(X.OutputsUpdate, this._outputPipeValues)))();
  }
  isConnected() {
    return this._state === re.Ready;
  }
  async connected() {
    return new Promise((t, n) => {
      if (this._state === re.Ready) {
        t();
        return;
      }
      let s;
      s = this.addListenerReturnDisposer(U.Connected, () => {
        t(), s();
      });
    });
  }
  addListenerReturnDisposer(t, n) {
    return super.addListener(t, n), () => {
      super.removeListener(t, n);
    };
  }
  log(t, n, s) {
    this.debug && this.logInternal(t, n || this.color);
  }
  warn(t) {
    this.debug && this.logInternal(t, "000", this.color);
  }
  error(t) {
    this.logInternal(t, this.color, "f00");
  }
  logInternal(t, n, s) {
    let i;
    typeof t == "string" ? i = t : typeof t == "number" ? i = t + "" : i = JSON.stringify(t), n = n && n + "", i = (this.id ? `Metaframe[${this.id}] ` : "") + `${i}`, Rt(i, n, s);
  }
  dispose() {
    super.removeAllListeners(), window.removeEventListener("message", this.onMessage), this.disableNotifyOnHashUrlChange(), this._inputPipeValues = void 0, this._outputPipeValues = void 0;
  }
  addListener(t, n) {
    return super.addListener(t, n), t === U.Inputs && window.setTimeout(() => {
      this._inputPipeValues && n(this._inputPipeValues);
    }, 0), this;
  }
  onInput(t, n) {
    return this.addListenerReturnDisposer(U.Input, (s, i) => {
      t === s && n(i);
    });
  }
  onInputs(t) {
    return this.addListenerReturnDisposer(U.Inputs, t);
  }
  setInput(t, n) {
    var s = {};
    s[t] = n, this.setInputs(s);
  }
  async setInputs(t) {
    this.isInputOutputBlobSerialization && (t = await Ce(t)), this.sendRpc(X.InputsUpdate, t);
  }
  async setInternalInputsAndNotify(t) {
    this.isInputOutputBlobSerialization && (t = await Ce(t));
    const n = t;
    if (this._inputPipeValues = ze(this._inputPipeValues, t), this._inputPipeValues !== n) {
      Object.keys(t).forEach((s) => {
        try {
          this.emit(U.Input, s, t[s]);
        } catch (i) {
          console.error(`Error emitting input ${s}: ${i}`), this.emit(U.Error, `Error emitting input ${s}: ${i}`);
        }
      });
      try {
        this.emit(U.Inputs, t);
      } catch (s) {
        console.error(`Error emitting inputs: ${s}`), this.emit(U.Error, `Error emitting inputs: ${s}`);
      }
    }
  }
  getInput(t) {
    return console.assert(!!t), this._inputPipeValues[t];
  }
  getInputs() {
    return this._inputPipeValues;
  }
  setOutput(t, n) {
    console.assert(!!t);
    var s = {};
    s[t] = n, this.setOutputs(s);
  }
  async setOutputs(t) {
    this.isInputOutputBlobSerialization && (t = await We(t));
    const n = t;
    this._outputPipeValues = ze(this._outputPipeValues, t), this._outputPipeValues !== n && this._state === re.Ready && this.sendRpc(X.OutputsUpdate, t);
  }
  disableNotifyOnHashUrlChange() {
    window.removeEventListener("hashchange", this._onHashUrlChange);
  }
  _onHashUrlChange(t) {
    const n = {
      hash: window.location.hash,
      metaframe: this.id
    };
    this.sendRpc(X.HashParamsUpdate, n);
  }
  sendRpc(t, n) {
    if (this._isIframe) {
      const s = {
        jsonrpc: "2.0",
        id: ++this._messageSendCount,
        method: t,
        params: n,
        iframeId: this.id,
        parentId: this._parentId
      };
      window.parent && window.parent.postMessage(s, "*");
    } else
      this.log("Cannot send JSON-RPC window message: there is no window.parent which means we are not an iframe");
  }
  onMessage(t) {
    if (typeof t.data == "object") {
      let s = t.data;
      if (s.jsonrpc === "2.0") {
        var n = s.method;
        if (!(n == fe.SetupIframeServerResponse || s.parentId == this._parentId && s.iframeId == this.id)) {
          this.log(`window.message: received message but jsonrpc.parentId=${s.parentId} _parentId=${this._parentId} jsonrpc.iframeId=${s.iframeId} id=${this.id}`);
          return;
        }
        switch (n) {
          case fe.SetupIframeServerResponse:
            this._resolveSetupIframeServerResponse(s.params);
            break;
          case fe.InputsUpdate:
            if (this._state !== re.Ready)
              throw "Got InputsUpdate but metaframe is not MetaframeLoadingState.Ready";
            this.setInternalInputsAndNotify(s.params.inputs);
            break;
          case fe.MessageAck:
            this.debug && this.log(`ACK: ${JSON.stringify(s)}`);
            break;
          default:
            this.debug && this.log(`window.message: unknown JSON-RPC method: ${JSON.stringify(s)}`);
            break;
        }
        this.listenerCount(U.Message) > 0 && this.emit(U.Message, s);
      }
    }
  }
  setParameter(t, n) {
    Ae(t, n);
  }
  getParameter(t) {
    return ms(t);
  }
  setParameterBoolean(t, n) {
    Es(t, n);
  }
  getParameterBoolean(t) {
    return Ms(t);
  }
  setParameterJson(t, n) {
    gs(t, n);
  }
  getParameterJson(t) {
    return bs(t);
  }
  setParameterBase64(t, n) {
    Cs(t, n);
  }
  getParameterBase64(t) {
    return $s(t);
  }
  setParameterFloat(t, n) {
    cn(t, n);
  }
  getParameterFloat(t) {
    return ws(t);
  }
  setParameterInt(t, n) {
    Os(t, n);
  }
  getParameterInt(t) {
    return As(t);
  }
  deleteParameter(t) {
    Ae(t, void 0);
  }
}
te.version = An;
te.ERROR = U.Error;
te.CONNECTED = U.Connected;
te.INPUT = U.Input;
te.INPUTS = U.Inputs;
te.MESSAGE = U.Message;
te.deserializeInputs = Ce;
te.serializeInputs = We;
var Ke = {};
const ie = "\\\\/", kt = `[^${ie}]`, ce = "\\.", ks = "\\+", Ns = "\\?", Xe = "\\/", js = "(?=.)", dn = "[^/]", At = `(?:${Xe}|$)`, mn = `(?:^|${Xe})`, St = `${ce}{1,2}${At}`, Us = `(?!${ce})`, Bs = `(?!${mn}${St})`, Fs = `(?!${ce}{0,1}${At})`, zs = `(?!${St})`, Gs = `[^.${Xe}]`, Vs = `${dn}*?`, Js = "/", yn = {
  DOT_LITERAL: ce,
  PLUS_LITERAL: ks,
  QMARK_LITERAL: Ns,
  SLASH_LITERAL: Xe,
  ONE_CHAR: js,
  QMARK: dn,
  END_ANCHOR: At,
  DOTS_SLASH: St,
  NO_DOT: Us,
  NO_DOTS: Bs,
  NO_DOT_SLASH: Fs,
  NO_DOTS_SLASH: zs,
  QMARK_NO_DOT: Gs,
  STAR: Vs,
  START_ANCHOR: mn,
  SEP: Js
}, Ws = {
  ...yn,
  SLASH_LITERAL: `[${ie}]`,
  QMARK: kt,
  STAR: `${kt}*?`,
  DOTS_SLASH: `${ce}{1,2}(?:[${ie}]|$)`,
  NO_DOT: `(?!${ce})`,
  NO_DOTS: `(?!(?:^|[${ie}])${ce}{1,2}(?:[${ie}]|$))`,
  NO_DOT_SLASH: `(?!${ce}{0,1}(?:[${ie}]|$))`,
  NO_DOTS_SLASH: `(?!${ce}{1,2}(?:[${ie}]|$))`,
  QMARK_NO_DOT: `[^.${ie}]`,
  START_ANCHOR: `(?:^|[${ie}])`,
  END_ANCHOR: `(?:[${ie}]|$)`,
  SEP: "\\"
}, Ks = {
  alnum: "a-zA-Z0-9",
  alpha: "a-zA-Z",
  ascii: "\\x00-\\x7F",
  blank: " \\t",
  cntrl: "\\x00-\\x1F\\x7F",
  digit: "0-9",
  graph: "\\x21-\\x7E",
  lower: "a-z",
  print: "\\x20-\\x7E ",
  punct: "\\-!\"#$%&'()\\*+,./:;<=>?@[\\]^_`{|}~",
  space: " \\t\\r\\n\\v\\f",
  upper: "A-Z",
  word: "A-Za-z0-9_",
  xdigit: "A-Fa-f0-9"
};
var qe = {
  MAX_LENGTH: 1024 * 64,
  POSIX_REGEX_SOURCE: Ks,
  // regular expressions
  REGEX_BACKSLASH: /\\(?![*+?^${}(|)[\]])/g,
  REGEX_NON_SPECIAL_CHARS: /^[^@![\].,$*+?^{}()|\\/]+/,
  REGEX_SPECIAL_CHARS: /[-*+?.^${}(|)[\]]/,
  REGEX_SPECIAL_CHARS_BACKREF: /(\\?)((\W)(\3*))/g,
  REGEX_SPECIAL_CHARS_GLOBAL: /([-*+?.^${}(|)[\]])/g,
  REGEX_REMOVE_BACKSLASH: /(?:\[.*?[^\\]\]|\\(?=.))/g,
  // Replace globs with equivalent patterns to reduce parsing time.
  REPLACEMENTS: {
    "***": "*",
    "**/**": "**",
    "**/**/**": "**"
  },
  // Digits
  CHAR_0: 48,
  /* 0 */
  CHAR_9: 57,
  /* 9 */
  // Alphabet chars.
  CHAR_UPPERCASE_A: 65,
  /* A */
  CHAR_LOWERCASE_A: 97,
  /* a */
  CHAR_UPPERCASE_Z: 90,
  /* Z */
  CHAR_LOWERCASE_Z: 122,
  /* z */
  CHAR_LEFT_PARENTHESES: 40,
  /* ( */
  CHAR_RIGHT_PARENTHESES: 41,
  /* ) */
  CHAR_ASTERISK: 42,
  /* * */
  // Non-alphabetic chars.
  CHAR_AMPERSAND: 38,
  /* & */
  CHAR_AT: 64,
  /* @ */
  CHAR_BACKWARD_SLASH: 92,
  /* \ */
  CHAR_CARRIAGE_RETURN: 13,
  /* \r */
  CHAR_CIRCUMFLEX_ACCENT: 94,
  /* ^ */
  CHAR_COLON: 58,
  /* : */
  CHAR_COMMA: 44,
  /* , */
  CHAR_DOT: 46,
  /* . */
  CHAR_DOUBLE_QUOTE: 34,
  /* " */
  CHAR_EQUAL: 61,
  /* = */
  CHAR_EXCLAMATION_MARK: 33,
  /* ! */
  CHAR_FORM_FEED: 12,
  /* \f */
  CHAR_FORWARD_SLASH: 47,
  /* / */
  CHAR_GRAVE_ACCENT: 96,
  /* ` */
  CHAR_HASH: 35,
  /* # */
  CHAR_HYPHEN_MINUS: 45,
  /* - */
  CHAR_LEFT_ANGLE_BRACKET: 60,
  /* < */
  CHAR_LEFT_CURLY_BRACE: 123,
  /* { */
  CHAR_LEFT_SQUARE_BRACKET: 91,
  /* [ */
  CHAR_LINE_FEED: 10,
  /* \n */
  CHAR_NO_BREAK_SPACE: 160,
  /* \u00A0 */
  CHAR_PERCENT: 37,
  /* % */
  CHAR_PLUS: 43,
  /* + */
  CHAR_QUESTION_MARK: 63,
  /* ? */
  CHAR_RIGHT_ANGLE_BRACKET: 62,
  /* > */
  CHAR_RIGHT_CURLY_BRACE: 125,
  /* } */
  CHAR_RIGHT_SQUARE_BRACKET: 93,
  /* ] */
  CHAR_SEMICOLON: 59,
  /* ; */
  CHAR_SINGLE_QUOTE: 39,
  /* ' */
  CHAR_SPACE: 32,
  /*   */
  CHAR_TAB: 9,
  /* \t */
  CHAR_UNDERSCORE: 95,
  /* _ */
  CHAR_VERTICAL_LINE: 124,
  /* | */
  CHAR_ZERO_WIDTH_NOBREAK_SPACE: 65279,
  /* \uFEFF */
  /**
   * Create EXTGLOB_CHARS
   */
  extglobChars(e) {
    return {
      "!": { type: "negate", open: "(?:(?!(?:", close: `))${e.STAR})` },
      "?": { type: "qmark", open: "(?:", close: ")?" },
      "+": { type: "plus", open: "(?:", close: ")+" },
      "*": { type: "star", open: "(?:", close: ")*" },
      "@": { type: "at", open: "(?:", close: ")" }
    };
  },
  /**
   * Create GLOB_CHARS
   */
  globChars(e) {
    return e === !0 ? Ws : yn;
  }
};
(function(e) {
  const {
    REGEX_BACKSLASH: t,
    REGEX_REMOVE_BACKSLASH: n,
    REGEX_SPECIAL_CHARS: s,
    REGEX_SPECIAL_CHARS_GLOBAL: i
  } = qe;
  e.isObject = (o) => o !== null && typeof o == "object" && !Array.isArray(o), e.hasRegexChars = (o) => s.test(o), e.isRegexChar = (o) => o.length === 1 && e.hasRegexChars(o), e.escapeRegex = (o) => o.replace(i, "\\$1"), e.toPosixSlashes = (o) => o.replace(t, "/"), e.removeBackslashes = (o) => o.replace(n, (r) => r === "\\" ? "" : r), e.supportsLookbehinds = () => {
    const o = process.version.slice(1).split(".").map(Number);
    return o.length === 3 && o[0] >= 9 || o[0] === 8 && o[1] >= 10;
  }, e.escapeLast = (o, r, a) => {
    const u = o.lastIndexOf(r, a);
    return u === -1 ? o : o[u - 1] === "\\" ? e.escapeLast(o, r, u - 1) : `${o.slice(0, u)}\\${o.slice(u)}`;
  }, e.removePrefix = (o, r = {}) => {
    let a = o;
    return a.startsWith("./") && (a = a.slice(2), r.prefix = "./"), a;
  }, e.wrapOutput = (o, r = {}, a = {}) => {
    const u = a.contains ? "" : "^", f = a.contains ? "" : "$";
    let c = `${u}(?:${o})${f}`;
    return r.negated === !0 && (c = `(?:^(?!${c}).*$)`), c;
  }, e.basename = (o, { windows: r } = {}) => r ? o.replace(/[\\/]$/, "").replace(/.*[\\/]/, "") : o.replace(/\/$/, "").replace(/.*\//, "");
})(Ke);
const Nt = Ke, {
  CHAR_ASTERISK: et,
  /* * */
  CHAR_AT: Xs,
  /* @ */
  CHAR_BACKWARD_SLASH: Me,
  /* \ */
  CHAR_COMMA: qs,
  /* , */
  CHAR_DOT: tt,
  /* . */
  CHAR_EXCLAMATION_MARK: jt,
  /* ! */
  CHAR_FORWARD_SLASH: _n,
  /* / */
  CHAR_LEFT_CURLY_BRACE: nt,
  /* { */
  CHAR_LEFT_PARENTHESES: st,
  /* ( */
  CHAR_LEFT_SQUARE_BRACKET: Qs,
  /* [ */
  CHAR_PLUS: Ys,
  /* + */
  CHAR_QUESTION_MARK: Ut,
  /* ? */
  CHAR_RIGHT_CURLY_BRACE: Zs,
  /* } */
  CHAR_RIGHT_PARENTHESES: Bt,
  /* ) */
  CHAR_RIGHT_SQUARE_BRACKET: ei
  /* ] */
} = qe, Ft = (e) => e === _n || e === Me, zt = (e) => {
  e.isPrefix !== !0 && (e.depth = e.isGlobstar ? 1 / 0 : 1);
}, ti = (e, t) => {
  const n = t || {}, s = e.length - 1, i = n.parts === !0 || n.scanToEnd === !0, o = [], r = [], a = [];
  let u = e, f = -1, c = 0, d = 0, y = !1, w = !1, _ = !1, S = !1, v = !1, x = !1, b = !1, A = !1, I = !1, R = 0, D, O, L = { value: "", depth: 0, isGlob: !1 };
  const z = () => f >= s, h = () => u.charCodeAt(f + 1), k = () => (D = O, u.charCodeAt(++f));
  for (; f < s; ) {
    O = k();
    let J;
    if (O === Me) {
      b = L.backslashes = !0, O = k(), O === nt && (x = !0);
      continue;
    }
    if (x === !0 || O === nt) {
      for (R++; z() !== !0 && (O = k()); ) {
        if (O === Me) {
          b = L.backslashes = !0, k();
          continue;
        }
        if (O === nt) {
          R++;
          continue;
        }
        if (x !== !0 && O === tt && (O = k()) === tt) {
          if (y = L.isBrace = !0, _ = L.isGlob = !0, I = !0, i === !0)
            continue;
          break;
        }
        if (x !== !0 && O === qs) {
          if (y = L.isBrace = !0, _ = L.isGlob = !0, I = !0, i === !0)
            continue;
          break;
        }
        if (O === Zs && (R--, R === 0)) {
          x = !1, y = L.isBrace = !0, I = !0;
          break;
        }
      }
      if (i === !0)
        continue;
      break;
    }
    if (O === _n) {
      if (o.push(f), r.push(L), L = { value: "", depth: 0, isGlob: !1 }, I === !0)
        continue;
      if (D === tt && f === c + 1) {
        c += 2;
        continue;
      }
      d = f + 1;
      continue;
    }
    if (n.noext !== !0 && (O === Ys || O === Xs || O === et || O === Ut || O === jt) === !0 && h() === st) {
      if (_ = L.isGlob = !0, S = L.isExtglob = !0, I = !0, i === !0) {
        for (; z() !== !0 && (O = k()); ) {
          if (O === Me) {
            b = L.backslashes = !0, O = k();
            continue;
          }
          if (O === Bt) {
            _ = L.isGlob = !0, I = !0;
            break;
          }
        }
        continue;
      }
      break;
    }
    if (O === et) {
      if (D === et && (v = L.isGlobstar = !0), _ = L.isGlob = !0, I = !0, i === !0)
        continue;
      break;
    }
    if (O === Ut) {
      if (_ = L.isGlob = !0, I = !0, i === !0)
        continue;
      break;
    }
    if (O === Qs)
      for (; z() !== !0 && (J = k()); ) {
        if (J === Me) {
          b = L.backslashes = !0, k();
          continue;
        }
        if (J === ei) {
          if (w = L.isBracket = !0, _ = L.isGlob = !0, I = !0, i === !0)
            continue;
          break;
        }
      }
    if (n.nonegate !== !0 && O === jt && f === c) {
      A = L.negated = !0, c++;
      continue;
    }
    if (n.noparen !== !0 && O === st) {
      if (_ = L.isGlob = !0, i === !0) {
        for (; z() !== !0 && (O = k()); ) {
          if (O === st) {
            b = L.backslashes = !0, O = k();
            continue;
          }
          if (O === Bt) {
            I = !0;
            break;
          }
        }
        continue;
      }
      break;
    }
    if (_ === !0) {
      if (I = !0, i === !0)
        continue;
      break;
    }
  }
  n.noext === !0 && (S = !1, _ = !1);
  let H = u, he = "", l = "";
  c > 0 && (he = u.slice(0, c), u = u.slice(c), d -= c), H && _ === !0 && d > 0 ? (H = u.slice(0, d), l = u.slice(d)) : _ === !0 ? (H = "", l = u) : H = u, H && H !== "" && H !== "/" && H !== u && Ft(H.charCodeAt(H.length - 1)) && (H = H.slice(0, -1)), n.unescape === !0 && (l && (l = Nt.removeBackslashes(l)), H && b === !0 && (H = Nt.removeBackslashes(H)));
  const p = {
    prefix: he,
    input: e,
    start: c,
    base: H,
    glob: l,
    isBrace: y,
    isBracket: w,
    isGlob: _,
    isExtglob: S,
    isGlobstar: v,
    negated: A
  };
  if (n.tokens === !0 && (p.maxDepth = 0, Ft(O) || r.push(L), p.tokens = r), n.parts === !0 || n.tokens === !0) {
    let J;
    for (let T = 0; T < o.length; T++) {
      const se = J ? J + 1 : c, ae = o[T], q = e.slice(se, ae);
      n.tokens && (T === 0 && c !== 0 ? (r[T].isPrefix = !0, r[T].value = he) : r[T].value = q, zt(r[T]), p.maxDepth += r[T].depth), (T !== 0 || q !== "") && a.push(q), J = ae;
    }
    if (J && J + 1 < e.length) {
      const T = e.slice(J + 1);
      a.push(T), n.tokens && (r[r.length - 1].value = T, zt(r[r.length - 1]), p.maxDepth += r[r.length - 1].depth);
    }
    p.slashes = o, p.parts = a;
  }
  return p;
};
var ni = ti;
const Ge = qe, Z = Ke, {
  MAX_LENGTH: Ve,
  POSIX_REGEX_SOURCE: si,
  REGEX_NON_SPECIAL_CHARS: ii,
  REGEX_SPECIAL_CHARS_BACKREF: ri,
  REPLACEMENTS: gn
} = Ge, oi = (e, t) => {
  if (typeof t.expandRange == "function")
    return t.expandRange(...e, t);
  e.sort();
  const n = `[${e.join("-")}]`;
  try {
    new RegExp(n);
  } catch {
    return e.map((i) => Z.escapeRegex(i)).join("..");
  }
  return n;
}, ve = (e, t) => `Missing ${e}: "${t}" - use "\\\\${t}" to match literal characters`, bn = (e, t) => {
  if (typeof e != "string")
    throw new TypeError("Expected a string");
  e = gn[e] || e;
  const n = { ...t }, s = typeof n.maxLength == "number" ? Math.min(Ve, n.maxLength) : Ve;
  let i = e.length;
  if (i > s)
    throw new SyntaxError(`Input length: ${i}, exceeds maximum allowed length: ${s}`);
  const o = { type: "bos", value: "", output: n.prepend || "" }, r = [o], a = n.capture ? "" : "?:", u = Ge.globChars(n.windows), f = Ge.extglobChars(u), {
    DOT_LITERAL: c,
    PLUS_LITERAL: d,
    SLASH_LITERAL: y,
    ONE_CHAR: w,
    DOTS_SLASH: _,
    NO_DOT: S,
    NO_DOT_SLASH: v,
    NO_DOTS_SLASH: x,
    QMARK: b,
    QMARK_NO_DOT: A,
    STAR: I,
    START_ANCHOR: R
  } = u, D = (g) => `(${a}(?:(?!${R}${g.dot ? _ : c}).)*?)`, O = n.dot ? "" : S, L = n.dot ? b : A;
  let z = n.bash === !0 ? D(n) : I;
  n.capture && (z = `(${z})`), typeof n.noext == "boolean" && (n.noextglob = n.noext);
  const h = {
    input: e,
    index: -1,
    start: 0,
    dot: n.dot === !0,
    consumed: "",
    output: "",
    prefix: "",
    backtrack: !1,
    negated: !1,
    brackets: 0,
    braces: 0,
    parens: 0,
    quotes: 0,
    globstar: !1,
    tokens: r
  };
  e = Z.removePrefix(e, h), i = e.length;
  const k = [], H = [], he = [];
  let l = o, p;
  const J = () => h.index === i - 1, T = h.peek = (g = 1) => e[h.index + g], se = h.advance = () => e[++h.index], ae = () => e.slice(h.index + 1), q = (g = "", N = 0) => {
    h.consumed += g, h.index += N;
  }, Te = (g) => {
    h.output += g.output != null ? g.output : g.value, q(g.value);
  }, Rn = () => {
    let g = 1;
    for (; T() === "!" && (T(2) !== "(" || T(3) === "?"); )
      se(), h.start++, g++;
    return g % 2 === 0 ? !1 : (h.negated = !0, h.start++, !0);
  }, De = (g) => {
    h[g]++, he.push(g);
  }, me = (g) => {
    h[g]--, he.pop();
  }, C = (g) => {
    if (l.type === "globstar") {
      const N = h.braces > 0 && (g.type === "comma" || g.type === "brace"), m = g.extglob === !0 || k.length && (g.type === "pipe" || g.type === "paren");
      g.type !== "slash" && g.type !== "paren" && !N && !m && (h.output = h.output.slice(0, -l.output.length), l.type = "star", l.value = "*", l.output = z, h.output += l.output);
    }
    if (k.length && g.type !== "paren" && !f[g.value] && (k[k.length - 1].inner += g.value), (g.value || g.output) && Te(g), l && l.type === "text" && g.type === "text") {
      l.value += g.value, l.output = (l.output || "") + g.value;
      return;
    }
    g.prev = l, r.push(g), l = g;
  }, He = (g, N) => {
    const m = { ...f[N], conditions: 1, inner: "" };
    m.prev = l, m.parens = h.parens, m.output = h.output;
    const P = (n.capture ? "(" : "") + m.open;
    De("parens"), C({ type: g, value: N, output: h.output ? "" : w }), C({ type: "paren", extglob: !0, value: se(), output: P }), k.push(m);
  }, On = (g) => {
    let N = g.close + (n.capture ? ")" : "");
    if (g.type === "negate") {
      let m = z;
      g.inner && g.inner.length > 1 && g.inner.includes("/") && (m = D(n)), (m !== z || J() || /^\)+$/.test(ae())) && (N = g.close = `)$))${m}`), g.prev.type === "bos" && J() && (h.negatedExtglob = !0);
    }
    C({ type: "paren", extglob: !0, value: p, output: N }), me("parens");
  };
  if (n.fastpaths !== !1 && !/(^[*!]|[/()[\]{}"])/.test(e)) {
    let g = !1, N = e.replace(ri, (m, P, j, W, G, Qe) => W === "\\" ? (g = !0, m) : W === "?" ? P ? P + W + (G ? b.repeat(G.length) : "") : Qe === 0 ? L + (G ? b.repeat(G.length) : "") : b.repeat(j.length) : W === "." ? c.repeat(j.length) : W === "*" ? P ? P + W + (G ? z : "") : z : P ? m : `\\${m}`);
    return g === !0 && (n.unescape === !0 ? N = N.replace(/\\/g, "") : N = N.replace(/\\+/g, (m) => m.length % 2 === 0 ? "\\\\" : m ? "\\" : "")), N === e && n.contains === !0 ? (h.output = e, h) : (h.output = Z.wrapOutput(N, h, t), h);
  }
  for (; !J(); ) {
    if (p = se(), p === "\0")
      continue;
    if (p === "\\") {
      const m = T();
      if (m === "/" && n.bash !== !0 || m === "." || m === ";")
        continue;
      if (!m) {
        p += "\\", C({ type: "text", value: p });
        continue;
      }
      const P = /^\\+/.exec(ae());
      let j = 0;
      if (P && P[0].length > 2 && (j = P[0].length, h.index += j, j % 2 !== 0 && (p += "\\")), n.unescape === !0 ? p = se() || "" : p += se() || "", h.brackets === 0) {
        C({ type: "text", value: p });
        continue;
      }
    }
    if (h.brackets > 0 && (p !== "]" || l.value === "[" || l.value === "[^")) {
      if (n.posix !== !1 && p === ":") {
        const m = l.value.slice(1);
        if (m.includes("[") && (l.posix = !0, m.includes(":"))) {
          const P = l.value.lastIndexOf("["), j = l.value.slice(0, P), W = l.value.slice(P + 2), G = si[W];
          if (G) {
            l.value = j + G, h.backtrack = !0, se(), !o.output && r.indexOf(l) === 1 && (o.output = w);
            continue;
          }
        }
      }
      (p === "[" && T() !== ":" || p === "-" && T() === "]") && (p = `\\${p}`), p === "]" && (l.value === "[" || l.value === "[^") && (p = `\\${p}`), n.posix === !0 && p === "!" && l.value === "[" && (p = "^"), l.value += p, Te({ value: p });
      continue;
    }
    if (h.quotes === 1 && p !== '"') {
      p = Z.escapeRegex(p), l.value += p, Te({ value: p });
      continue;
    }
    if (p === '"') {
      h.quotes = h.quotes === 1 ? 0 : 1, n.keepQuotes === !0 && C({ type: "text", value: p });
      continue;
    }
    if (p === "(") {
      De("parens"), C({ type: "paren", value: p });
      continue;
    }
    if (p === ")") {
      if (h.parens === 0 && n.strictBrackets === !0)
        throw new SyntaxError(ve("opening", "("));
      const m = k[k.length - 1];
      if (m && h.parens === m.parens + 1) {
        On(k.pop());
        continue;
      }
      C({ type: "paren", value: p, output: h.parens ? ")" : "\\)" }), me("parens");
      continue;
    }
    if (p === "[") {
      if (n.nobracket === !0 || !ae().includes("]")) {
        if (n.nobracket !== !0 && n.strictBrackets === !0)
          throw new SyntaxError(ve("closing", "]"));
        p = `\\${p}`;
      } else
        De("brackets");
      C({ type: "bracket", value: p });
      continue;
    }
    if (p === "]") {
      if (n.nobracket === !0 || l && l.type === "bracket" && l.value.length === 1) {
        C({ type: "text", value: p, output: `\\${p}` });
        continue;
      }
      if (h.brackets === 0) {
        if (n.strictBrackets === !0)
          throw new SyntaxError(ve("opening", "["));
        C({ type: "text", value: p, output: `\\${p}` });
        continue;
      }
      me("brackets");
      const m = l.value.slice(1);
      if (l.posix !== !0 && m[0] === "^" && !m.includes("/") && (p = `/${p}`), l.value += p, Te({ value: p }), n.literalBrackets === !1 || Z.hasRegexChars(m))
        continue;
      const P = Z.escapeRegex(l.value);
      if (h.output = h.output.slice(0, -l.value.length), n.literalBrackets === !0) {
        h.output += P, l.value = P;
        continue;
      }
      l.value = `(${a}${P}|${l.value})`, h.output += l.value;
      continue;
    }
    if (p === "{" && n.nobrace !== !0) {
      De("braces");
      const m = {
        type: "brace",
        value: p,
        output: "(",
        outputIndex: h.output.length,
        tokensIndex: h.tokens.length
      };
      H.push(m), C(m);
      continue;
    }
    if (p === "}") {
      const m = H[H.length - 1];
      if (n.nobrace === !0 || !m) {
        C({ type: "text", value: p, output: p });
        continue;
      }
      let P = ")";
      if (m.dots === !0) {
        const j = r.slice(), W = [];
        for (let G = j.length - 1; G >= 0 && (r.pop(), j[G].type !== "brace"); G--)
          j[G].type !== "dots" && W.unshift(j[G].value);
        P = oi(W, n), h.backtrack = !0;
      }
      if (m.comma !== !0 && m.dots !== !0) {
        const j = h.output.slice(0, m.outputIndex), W = h.tokens.slice(m.tokensIndex);
        m.value = m.output = "\\{", p = P = "\\}", h.output = j;
        for (const G of W)
          h.output += G.output || G.value;
      }
      C({ type: "brace", value: p, output: P }), me("braces"), H.pop();
      continue;
    }
    if (p === "|") {
      k.length > 0 && k[k.length - 1].conditions++, C({ type: "text", value: p });
      continue;
    }
    if (p === ",") {
      let m = p;
      const P = H[H.length - 1];
      P && he[he.length - 1] === "braces" && (P.comma = !0, m = "|"), C({ type: "comma", value: p, output: m });
      continue;
    }
    if (p === "/") {
      if (l.type === "dot" && h.index === h.start + 1) {
        h.start = h.index + 1, h.consumed = "", h.output = "", r.pop(), l = o;
        continue;
      }
      C({ type: "slash", value: p, output: y });
      continue;
    }
    if (p === ".") {
      if (h.braces > 0 && l.type === "dot") {
        l.value === "." && (l.output = c);
        const m = H[H.length - 1];
        l.type = "dots", l.output += p, l.value += p, m.dots = !0;
        continue;
      }
      if (h.braces + h.parens === 0 && l.type !== "bos" && l.type !== "slash") {
        C({ type: "text", value: p, output: c });
        continue;
      }
      C({ type: "dot", value: p, output: c });
      continue;
    }
    if (p === "?") {
      if (!(l && l.value === "(") && n.noextglob !== !0 && T() === "(" && T(2) !== "?") {
        He("qmark", p);
        continue;
      }
      if (l && l.type === "paren") {
        const P = T();
        let j = p;
        if (P === "<" && !Z.supportsLookbehinds())
          throw new Error("Node.js v10 or higher is required for regex lookbehinds");
        (l.value === "(" && !/[!=<:]/.test(P) || P === "<" && !/<([!=]|\w+>)/.test(ae())) && (j = `\\${p}`), C({ type: "text", value: p, output: j });
        continue;
      }
      if (n.dot !== !0 && (l.type === "slash" || l.type === "bos")) {
        C({ type: "qmark", value: p, output: A });
        continue;
      }
      C({ type: "qmark", value: p, output: b });
      continue;
    }
    if (p === "!") {
      if (n.noextglob !== !0 && T() === "(" && (T(2) !== "?" || !/[!=<:]/.test(T(3)))) {
        He("negate", p);
        continue;
      }
      if (n.nonegate !== !0 && h.index === 0) {
        Rn();
        continue;
      }
    }
    if (p === "+") {
      if (n.noextglob !== !0 && T() === "(" && T(2) !== "?") {
        He("plus", p);
        continue;
      }
      if (l && l.value === "(" || n.regex === !1) {
        C({ type: "plus", value: p, output: d });
        continue;
      }
      if (l && (l.type === "bracket" || l.type === "paren" || l.type === "brace") || h.parens > 0) {
        C({ type: "plus", value: p });
        continue;
      }
      C({ type: "plus", value: d });
      continue;
    }
    if (p === "@") {
      if (n.noextglob !== !0 && T() === "(" && T(2) !== "?") {
        C({ type: "at", extglob: !0, value: p, output: "" });
        continue;
      }
      C({ type: "text", value: p });
      continue;
    }
    if (p !== "*") {
      (p === "$" || p === "^") && (p = `\\${p}`);
      const m = ii.exec(ae());
      m && (p += m[0], h.index += m[0].length), C({ type: "text", value: p });
      continue;
    }
    if (l && (l.type === "globstar" || l.star === !0)) {
      l.type = "star", l.star = !0, l.value += p, l.output = z, h.backtrack = !0, h.globstar = !0, q(p);
      continue;
    }
    let g = ae();
    if (n.noextglob !== !0 && /^\([^?]/.test(g)) {
      He("star", p);
      continue;
    }
    if (l.type === "star") {
      if (n.noglobstar === !0) {
        q(p);
        continue;
      }
      const m = l.prev, P = m.prev, j = m.type === "slash" || m.type === "bos", W = P && (P.type === "star" || P.type === "globstar");
      if (n.bash === !0 && (!j || g[0] && g[0] !== "/")) {
        C({ type: "star", value: p, output: "" });
        continue;
      }
      const G = h.braces > 0 && (m.type === "comma" || m.type === "brace"), Qe = k.length && (m.type === "pipe" || m.type === "paren");
      if (!j && m.type !== "paren" && !G && !Qe) {
        C({ type: "star", value: p, output: "" });
        continue;
      }
      for (; g.slice(0, 3) === "/**"; ) {
        const ke = e[h.index + 4];
        if (ke && ke !== "/")
          break;
        g = g.slice(3), q("/**", 3);
      }
      if (m.type === "bos" && J()) {
        l.type = "globstar", l.value += p, l.output = D(n), h.output = l.output, h.globstar = !0, q(p);
        continue;
      }
      if (m.type === "slash" && m.prev.type !== "bos" && !W && J()) {
        h.output = h.output.slice(0, -(m.output + l.output).length), m.output = `(?:${m.output}`, l.type = "globstar", l.output = D(n) + (n.strictSlashes ? ")" : "|$)"), l.value += p, h.globstar = !0, h.output += m.output + l.output, q(p);
        continue;
      }
      if (m.type === "slash" && m.prev.type !== "bos" && g[0] === "/") {
        const ke = g[1] !== void 0 ? "|$" : "";
        h.output = h.output.slice(0, -(m.output + l.output).length), m.output = `(?:${m.output}`, l.type = "globstar", l.output = `${D(n)}${y}|${y}${ke})`, l.value += p, h.output += m.output + l.output, h.globstar = !0, q(p + se()), C({ type: "slash", value: "/", output: "" });
        continue;
      }
      if (m.type === "bos" && g[0] === "/") {
        l.type = "globstar", l.value += p, l.output = `(?:^|${y}|${D(n)}${y})`, h.output = l.output, h.globstar = !0, q(p + se()), C({ type: "slash", value: "/", output: "" });
        continue;
      }
      h.output = h.output.slice(0, -l.output.length), l.type = "globstar", l.output = D(n), l.value += p, h.output += l.output, h.globstar = !0, q(p);
      continue;
    }
    const N = { type: "star", value: p, output: z };
    if (n.bash === !0) {
      N.output = ".*?", (l.type === "bos" || l.type === "slash") && (N.output = O + N.output), C(N);
      continue;
    }
    if (l && (l.type === "bracket" || l.type === "paren") && n.regex === !0) {
      N.output = p, C(N);
      continue;
    }
    (h.index === h.start || l.type === "slash" || l.type === "dot") && (l.type === "dot" ? (h.output += v, l.output += v) : n.dot === !0 ? (h.output += x, l.output += x) : (h.output += O, l.output += O), T() !== "*" && (h.output += w, l.output += w)), C(N);
  }
  for (; h.brackets > 0; ) {
    if (n.strictBrackets === !0)
      throw new SyntaxError(ve("closing", "]"));
    h.output = Z.escapeLast(h.output, "["), me("brackets");
  }
  for (; h.parens > 0; ) {
    if (n.strictBrackets === !0)
      throw new SyntaxError(ve("closing", ")"));
    h.output = Z.escapeLast(h.output, "("), me("parens");
  }
  for (; h.braces > 0; ) {
    if (n.strictBrackets === !0)
      throw new SyntaxError(ve("closing", "}"));
    h.output = Z.escapeLast(h.output, "{"), me("braces");
  }
  if (n.strictSlashes !== !0 && (l.type === "star" || l.type === "bracket") && C({ type: "maybe_slash", value: "", output: `${y}?` }), h.backtrack === !0) {
    h.output = "";
    for (const g of h.tokens)
      h.output += g.output != null ? g.output : g.value, g.suffix && (h.output += g.suffix);
  }
  return h;
};
bn.fastpaths = (e, t) => {
  const n = { ...t }, s = typeof n.maxLength == "number" ? Math.min(Ve, n.maxLength) : Ve, i = e.length;
  if (i > s)
    throw new SyntaxError(`Input length: ${i}, exceeds maximum allowed length: ${s}`);
  e = gn[e] || e;
  const {
    DOT_LITERAL: o,
    SLASH_LITERAL: r,
    ONE_CHAR: a,
    DOTS_SLASH: u,
    NO_DOT: f,
    NO_DOTS: c,
    NO_DOTS_SLASH: d,
    STAR: y,
    START_ANCHOR: w
  } = Ge.globChars(n.windows), _ = n.dot ? c : f, S = n.dot ? d : f, v = n.capture ? "" : "?:", x = { negated: !1, prefix: "" };
  let b = n.bash === !0 ? ".*?" : y;
  n.capture && (b = `(${b})`);
  const A = (O) => O.noglobstar === !0 ? b : `(${v}(?:(?!${w}${O.dot ? u : o}).)*?)`, I = (O) => {
    switch (O) {
      case "*":
        return `${_}${a}${b}`;
      case ".*":
        return `${o}${a}${b}`;
      case "*.*":
        return `${_}${b}${o}${a}${b}`;
      case "*/*":
        return `${_}${b}${r}${a}${S}${b}`;
      case "**":
        return _ + A(n);
      case "**/*":
        return `(?:${_}${A(n)}${r})?${S}${a}${b}`;
      case "**/*.*":
        return `(?:${_}${A(n)}${r})?${S}${b}${o}${a}${b}`;
      case "**/.*":
        return `(?:${_}${A(n)}${r})?${o}${a}${b}`;
      default: {
        const L = /^(.*?)\.(\w+)$/.exec(O);
        if (!L)
          return;
        const z = I(L[1]);
        return z ? z + o + L[2] : void 0;
      }
    }
  }, R = Z.removePrefix(e, x);
  let D = I(R);
  return D && n.strictSlashes !== !0 && (D += `${r}?`), D;
};
var ai = bn;
const ui = ni, lt = ai, vn = Ke, ci = qe, fi = (e) => e && typeof e == "object" && !Array.isArray(e), F = (e, t, n = !1) => {
  if (Array.isArray(e)) {
    const c = e.map((y) => F(y, t, n));
    return (y) => {
      for (const w of c) {
        const _ = w(y);
        if (_)
          return _;
      }
      return !1;
    };
  }
  const s = fi(e) && e.tokens && e.input;
  if (e === "" || typeof e != "string" && !s)
    throw new TypeError("Expected pattern to be a non-empty string");
  const i = t || {}, o = i.windows, r = s ? F.compileRe(e, t) : F.makeRe(e, t, !1, !0), a = r.state;
  delete r.state;
  let u = () => !1;
  if (i.ignore) {
    const c = { ...t, ignore: null, onMatch: null, onResult: null };
    u = F(i.ignore, c, n);
  }
  const f = (c, d = !1) => {
    const { isMatch: y, match: w, output: _ } = F.test(c, r, t, { glob: e, posix: o }), S = { glob: e, state: a, regex: r, posix: o, input: c, output: _, match: w, isMatch: y };
    return typeof i.onResult == "function" && i.onResult(S), y === !1 ? (S.isMatch = !1, d ? S : !1) : u(c) ? (typeof i.onIgnore == "function" && i.onIgnore(S), S.isMatch = !1, d ? S : !1) : (typeof i.onMatch == "function" && i.onMatch(S), d ? S : !0);
  };
  return n && (f.state = a), f;
};
F.test = (e, t, n, { glob: s, posix: i } = {}) => {
  if (typeof e != "string")
    throw new TypeError("Expected input to be a string");
  if (e === "")
    return { isMatch: !1, output: "" };
  const o = n || {}, r = o.format || (i ? vn.toPosixSlashes : null);
  let a = e === s, u = a && r ? r(e) : e;
  return a === !1 && (u = r ? r(e) : e, a = u === s), (a === !1 || o.capture === !0) && (o.matchBase === !0 || o.basename === !0 ? a = F.matchBase(e, t, n, i) : a = t.exec(u)), { isMatch: !!a, match: a, output: u };
};
F.matchBase = (e, t, n) => (t instanceof RegExp ? t : F.makeRe(t, n)).test(vn.basename(e));
F.isMatch = (e, t, n) => F(t, n)(e);
F.parse = (e, t) => Array.isArray(e) ? e.map((n) => F.parse(n, t)) : lt(e, { ...t, fastpaths: !1 });
F.scan = (e, t) => ui(e, t);
F.compileRe = (e, t, n = !1, s = !1) => {
  if (n === !0)
    return e.output;
  const i = t || {}, o = i.contains ? "" : "^", r = i.contains ? "" : "$";
  let a = `${o}(?:${e.output})${r}`;
  e && e.negated === !0 && (a = `^(?!${a}).*$`);
  const u = F.toRegex(a, t);
  return s === !0 && (u.state = e), u;
};
F.makeRe = (e, t, n = !1, s = !1) => {
  if (!e || typeof e != "string")
    throw new TypeError("Expected a non-empty string");
  const i = t || {};
  let o = { negated: !1, fastpaths: !0 }, r = "", a;
  return e.startsWith("./") && (e = e.slice(2), r = o.prefix = "./"), i.fastpaths !== !1 && (e[0] === "." || e[0] === "*") && (a = lt.fastpaths(e, t)), a === void 0 ? (o = lt(e, t), o.prefix = r + (o.prefix || "")) : o.output = a, F.compileRe(o, t, n, s);
};
F.toRegex = (e, t) => {
  try {
    const n = t || {};
    return new RegExp(e, n.flags || (n.nocase ? "i" : ""));
  } catch (n) {
    if (t && t.debug === !0)
      throw n;
    return /$^/;
  }
};
F.constants = ci;
var li = F, pi = li;
const hi = /* @__PURE__ */ ht(pi), wn = dt(fetch), Di = async (e, t) => {
  const n = new URL(e);
  n.pathname = n.pathname + (n.pathname.endsWith("/") ? "metapage.json" : "/metapage.json");
  const i = await (await wn(n.href, {
    redirect: "follow",
    retries: 3,
    retryDelay: 1e3
  })).json();
  return await Zt(i, t || "1");
}, di = async (e, t) => {
  const n = new URL(e);
  n.pathname = n.pathname + (n.pathname.endsWith("/") ? "metaframe.json" : "/metaframe.json");
  const i = await (await wn(n.href, {
    redirect: "follow",
    retries: 3,
    retryDelay: 1e3
  })).json();
  return await en(i, t || "1");
}, Hi = (e) => e ? !(e != null && e.inputs && Object.keys(e.inputs).length > 0 || e != null && e.outputs && Object.keys(e.outputs).length > 0 || e != null && e.allow || e != null && e.metadata && Object.keys(e.metadata).length > 0) : !0;
class mi extends vt.EventEmitter {
  constructor(t, n, s, i, o, r = !1) {
    if (super(), this.inputs = {}, this.outputs = {}, this._disposables = [], this._rpcListeners = [], this._loaded = !1, this._onLoaded = [], this._sendInputsAfterRegistration = !1, this._cachedEventInputsUpdate = {
      iframeId: void 0,
      inputs: void 0
    }, this._cachedEventOutputsUpdate = {
      iframeId: null,
      inputs: null
    }, !n.startsWith("http")) {
      for (; n.startsWith("/"); )
        n = n.substring(1);
      n = window.location.protocol + "//" + window.location.hostname + (window.location.port && window.location.port != "" ? ":" + window.location.port : "") + "/" + n;
    }
    if (this.url = n, this._metapage = t, this._debug = r, r) {
      var a = new URL(this.url);
      a.searchParams.set(xe.mp_debug, "true"), this.url = a.href;
    }
    this.id = s, this._parentId = i, this._color = pn(this.id), this._consoleBackgroundColor = o, this._iframe = document.createElement("iframe"), this._iframe.name = this.id;
    const u = this;
    this.iframe = new Promise((f) => {
      Ot().then(async () => {
        var c, d, y, w;
        if (u._iframe) {
          if ((w = (y = (d = (c = this._metapage) == null ? void 0 : c._definition) == null ? void 0 : d.metaframes) == null ? void 0 : y[this.id]) != null && w.allow)
            u._iframe.allow = this._metapage._definition.metaframes[this.id].allow;
          else {
            const _ = await u.getDefinition();
            if (!u._iframe)
              return;
            _ && _.allow && (u._iframe.allow = _.allow);
          }
          u._iframe.src = this.url, f(u._iframe);
        }
      });
    }), this.ack = this.ack.bind(this), this.dispose = this.dispose.bind(this), this.getDefinition = this.getDefinition.bind(this), this.getDefinitionUrl = this.getDefinitionUrl.bind(this), this.log = this.log.bind(this), this.logInternal = this.logInternal.bind(this), this.onInput = this.onInput.bind(this), this.onInputs = this.onInputs.bind(this), this.onOutput = this.onOutput.bind(this), this.onOutputs = this.onOutputs.bind(this), this.register = this.register.bind(this), this.registered = this.registered.bind(this), this.sendInputs = this.sendInputs.bind(this), this.sendOrBufferPostMessage = this.sendOrBufferPostMessage.bind(this), this.sendRpc = this.sendRpc.bind(this), this.sendRpcInternal = this.sendRpcInternal.bind(this), this.setInput = this.setInput.bind(this), this.setInputs = this.setInputs.bind(this), this.setMetapage = this.setMetapage.bind(this), this.setOutput = this.setOutput.bind(this), this.setOutputs = this.setOutputs.bind(this), this.addListenerReturnDisposer = this.addListenerReturnDisposer.bind(this), this.isDisposed = this.isDisposed.bind(this);
  }
  addListenerReturnDisposer(t, n) {
    return super.addListener(t, n), () => {
      super.removeListener(t, n);
    };
  }
  setMetapage(t) {
    return this._metapage = t, this;
  }
  getDefinitionUrl() {
    var t = new URL(this.url);
    return t.pathname = t.pathname + (t.pathname.endsWith("/") ? "metaframe.json" : "/metaframe.json"), t.href;
  }
  async getDefinition() {
    if (this._definition)
      return this._definition;
    try {
      const n = un(this.url, "definition");
      if (n) {
        const s = await es(n);
        return this._definition = s, this._definition;
      }
    } catch (n) {
      this.emit(M.Warning, `Failed to convert metaframe definition from hash params. Error: ${n != null && n.message ? n == null ? void 0 : n.message : "unknown error"}`);
      return;
    }
    var t = this.getDefinitionUrl();
    try {
      const n = await di(this.url);
      if (n)
        return this._definition = n, this._definition;
    } catch (n) {
      this.emit(M.Warning, `Failed to fetch or convert: ${t}
Error: ${n != null && n.message ? n == null ? void 0 : n.message : n == null ? void 0 : n.toString()}`);
    }
  }
  setInput(t, n) {
    console.assert(!!t);
    var s = {};
    s[t] = n, this.setInputs(s);
  }
  setInputs(t) {
    this.log({ m: "MetapageIFrameRpcClient", inputs: t });
    const n = t;
    if (this.inputs = ze(this.inputs, t), this.inputs === n)
      return this;
    if (this._loaded || (this._sendInputsAfterRegistration = !0), this._iframe.parentNode && this._loaded && this.sendInputs(t), this.emit(M.Inputs, this.inputs), this._metapage.listenerCount(M.Inputs) > 0) {
      var s = {};
      s[this.id] = t, this._metapage.emit(M.Inputs, s);
    }
    return this;
  }
  setOutput(t, n) {
    console.assert(!!t);
    var s = {};
    s[t] = n, this.setOutputs(s);
  }
  setOutputs(t) {
    const n = t;
    if (this.outputs = ze(this.outputs, t), this.outputs === n)
      return this;
    if (this.emit(M.Outputs, t), this._metapage.listenerCount(M.Outputs) > 0) {
      var s = {};
      s[this.id] = this.outputs, this._metapage.emit(M.Outputs, s);
    }
  }
  onInputs(t) {
    return this.addListenerReturnDisposer(M.Inputs, t);
  }
  onInput(t, n) {
    var s = function(i) {
      i.hasOwnProperty(t) && n(i[t]);
    };
    return this.addListenerReturnDisposer(M.Inputs, s);
  }
  onOutputs(t) {
    return this.addListenerReturnDisposer(M.Outputs, t);
  }
  onOutput(t, n) {
    var s = function(i) {
      i.hasOwnProperty(t) && n(i[t]);
    };
    return this.addListenerReturnDisposer(M.Outputs, s);
  }
  isDisposed() {
    return this.inputs === void 0;
  }
  dispose() {
    for (super.removeAllListeners(); this._disposables && this._disposables.length > 0; ) {
      const t = this._disposables.pop();
      t && t();
    }
    this._rpcListeners = void 0, this.inputs = void 0, this.outputs = void 0, this._iframe && this._iframe.parentNode && this._iframe.parentNode.removeChild(this._iframe), this._iframe = void 0, this._bufferMessages = void 0, this._bufferTimeout && (window.clearInterval(this._bufferTimeout), this._bufferTimeout = void 0), this._metapage = void 0;
  }
  register() {
    var t = {
      iframeId: this.id,
      parentId: this._parentId,
      state: {
        inputs: this.inputs
      },
      version: Gt
    };
    this.sendRpcInternal(fe.SetupIframeServerResponse, t);
  }
  registered(t) {
    if (this.log({ m: "MetapageIFrameRpcClient.registered", inputs: this.inputs }), !this._loaded) {
      if (!t)
        throw "Cannot register without a version";
      for (this.version = t, this._loaded = !0; this._onLoaded && this._onLoaded.length > 0; )
        this._onLoaded.pop()();
      this._sendInputsAfterRegistration && this.sendInputs(this.inputs);
    }
  }
  async sendInputs(t) {
    t && (t = await We(t), !this.isDisposed() && this.sendRpc(fe.InputsUpdate, {
      inputs: t,
      parentId: this._parentId
    }));
  }
  sendRpc(t, n) {
    var s, i;
    if ((s = this == null ? void 0 : this._iframe) != null && s.parentNode && this._loaded)
      this.sendRpcInternal(t, n);
    else {
      (i = this == null ? void 0 : this._metapage) == null || i.error("sending rpc later");
      const o = this;
      this == null || this._onLoaded.push(() => {
        o.sendRpcInternal(t, n);
      });
    }
  }
  ack(t) {
    if (this._debug) {
      this.log("⚒ ⚒ ⚒ sending ack from client to frame");
      var n = {
        message: t
      };
      this.sendRpc(fe.MessageAck, n);
    }
  }
  log(t) {
    this._debug && this.logInternal(t);
  }
  logInternal(t) {
    let n;
    typeof t == "string" ? n = t : typeof t == "string" ? n = t + "" : n = JSON.stringify(t), Rt(`Metapage[${this._parentId}] Metaframe[${this.id}] ${n}`, this._color, this._consoleBackgroundColor);
  }
  sendRpcInternal(t, n) {
    const s = {
      id: "_",
      iframeId: this.id,
      jsonrpc: "2.0",
      method: t,
      params: n,
      parentId: this._parentId
    };
    this._iframe ? this.sendOrBufferPostMessage(s) : this._metapage ? this._metapage.error(`Cannot send to child iframe messageJSON=${JSON.stringify(s).substring(0, 200)}`) : console.error(`Cannot send to child iframe messageJSON=${JSON.stringify(s).substring(0, 200)}`);
  }
  sendOrBufferPostMessage(t) {
    if (this._iframe && this._iframe.contentWindow)
      this._iframe.contentWindow.postMessage(t, this.url);
    else if (this._bufferMessages)
      this._bufferMessages.push(t);
    else {
      this._bufferMessages = [t];
      const n = this;
      this._bufferTimeout = window.setInterval(function() {
        n._iframe && n._iframe.contentWindow && (n._bufferMessages.forEach((s) => n._iframe.contentWindow.postMessage(s, n.url)), window.clearInterval(n._bufferTimeout), n._bufferTimeout = void 0, n._bufferMessages = void 0);
      }, 0);
    }
  }
}
const ye = E({
  metaframes: {
    inputs: {},
    outputs: {}
  }
}, (e) => e), ki = (e) => Re(e), yi = (e, t) => !!(!t || t === "**" || e === t || hi.isMatch(e, t)), _i = "bcbcbc";
class ne extends Ps {
  static async from(t, n) {
    if (t == null)
      throw "Metapage definition cannot be null";
    if (typeof t == "string")
      try {
        t = JSON.parse(t);
      } catch {
        throw "Cannot parse into JSON:\n${metaPageDef}";
      }
    var s = new ne();
    return s.setDefinition(t);
  }
  constructor(t) {
    super(), this._state = ye, this._metaframes = E({}, (n) => n), this.debug = ft(), this._internalReceivedMessageCounter = 0, this._cachedInputLookupMap = E({}, (n) => n), this._inputMap = {}, this._id = t && t.id ? t.id : Ts(), this._consoleBackgroundColor = t && t.color ? t.color : _i, this.addPipe = this.addPipe.bind(this), this.dispose = this.dispose.bind(this), this.addMetaframe = this.addMetaframe.bind(this), this.getInputsFromOutput = this.getInputsFromOutput.bind(this), this.getMetaframe = this.getMetaframe.bind(this), this.getMetaframeIds = this.getMetaframeIds.bind(this), this.getMetaframe = this.getMetaframe.bind(this), this.getMetaframes = this.getMetaframes.bind(this), this.getState = this.getState.bind(this), this.getStateMetaframes = this.getStateMetaframes.bind(this), this.isValidJSONRpcMessage = this.isValidJSONRpcMessage.bind(this), this.log = this.log.bind(this), this.logInternal = this.logInternal.bind(this), this.metaframeIds = this.metaframeIds.bind(this), this.metaframes = this.metaframes.bind(this), this.onMessage = this.onMessage.bind(this), this.removeAll = this.removeAll.bind(this), this.removeMetaframe = this.removeMetaframe.bind(this), this.setDebugFromUrlParams = this.setDebugFromUrlParams.bind(this), this.setDefinition = this.setDefinition.bind(this), this.setInput = this.setInput.bind(this), this.setInputs = this.setInputs.bind(this), this.setInputStateOnlyMetaframeInputValue = this.setInputStateOnlyMetaframeInputValue.bind(this), this.setInputStateOnlyMetaframeInputMap = this.setInputStateOnlyMetaframeInputMap.bind(this), this.setInputStateOnlyMetapageInstanceInputs = this.setInputStateOnlyMetapageInstanceInputs.bind(this), this.setOutputStateOnlyMetaframeInputValue = this.setOutputStateOnlyMetaframeInputValue.bind(this), this.setOutputStateOnlyMetaframeInputMap = this.setOutputStateOnlyMetaframeInputMap.bind(this), this.setOutputStateOnlyMetapageInstanceInputs = this.setOutputStateOnlyMetapageInstanceInputs.bind(this), this.setMetadata = this.setMetadata.bind(this), this.setMetaframeClientInputAndSentClientEvent = this.setMetaframeClientInputAndSentClientEvent.bind(this), this.setState = this.setState.bind(this), this.isDisposed = this.isDisposed.bind(this), this._emitDefinitionEvent = this._emitDefinitionEvent.bind(this), Ot().then(() => {
      this.isDisposed() || (window.addEventListener("message", this.onMessage), this.log("Initialized"));
    });
  }
  isDisposed() {
    return this._metaframes === void 0;
  }
  addListenerReturnDisposer(t, n) {
    return super.addListener(t, n), () => {
      super.removeListener(t, n);
    };
  }
  setDebugFromUrlParams() {
    const t = new URL(window.location.href);
    return this.debug = ["debug", "mp_debug"].reduce((n, s) => n || t.searchParams.get(s) === "true" || t.searchParams.get(s) === "1", !1), this;
  }
  getState() {
    return this._state;
  }
  setState(t) {
    this._state = E(t, (n) => n), this.getMetaframeIds().forEach((n) => {
      this.getMetaframe(n).setInputs(this._state.metaframes.inputs[n]), this.getMetaframe(n).setOutputs(this._state.metaframes.outputs[n]);
    }), this.listenerCount(M.State) > 0 && ye !== this._state && this.emit(M.State, this._state);
  }
  getStateMetaframes() {
    return this._state.metaframes;
  }
  getDefinition() {
    return this._definition;
  }
  async setDefinition(t, n) {
    if (!t.version)
      throw "Metapage definition must have a version";
    const s = await Vn(t);
    if (this.isDisposed())
      return this;
    s.metaframes && Object.keys(s.metaframes).forEach((o) => {
      var r = s.metaframes[o];
      if (typeof r != "object")
        throw this.emitErrorMessage(`Metaframe "${o}" is not an object`), `Metaframe "${o}" is not an object`;
      if (!r.url)
        throw this.emitErrorMessage(`Metaframe "${o}" missing field: url`), `Metaframe "${o}" missing field: url`;
    });
    const i = this._definition;
    return this._definition = s, Object.keys(this._metaframes).forEach((o) => {
      (!s.metaframes || !s.metaframes[o]) && this.removeMetaframe(o);
    }), n && (this._state = E(n, (o) => o)), s.metaframes && Object.keys(s.metaframes).forEach((o) => {
      if (!this._metaframes.hasOwnProperty(o)) {
        const r = s.metaframes[o];
        this.addMetaframe(o, r);
      }
    }), i !== ln && window.setTimeout(() => {
      !this.isDisposed() && s === this._definition && (this._emitDefinitionEvent(), n && this.listenerCount(M.State) > 0 && ye !== this._state && this.emit(M.State, this._state));
    }, 0), this;
  }
  setMetadata(t) {
    this._definition = E(this._definition, (n) => {
      n.meta = t;
    }), this._emitDefinitionEvent();
  }
  _emitDefinitionEvent() {
    if (this.listenerCount(M.Definition) > 0) {
      const t = {
        definition: this._definition,
        metaframes: this._metaframes
      };
      this.emit(M.Definition, t);
    }
  }
  addPipe(t, n) {
    this._inputMap = E(this._inputMap, (s) => {
      s[t] || (s[t] = []), s[t].push(n);
    });
  }
  removeMetaframe(t) {
    this._metaframes[t] && (this._metaframes[t].dispose(), this._metaframes = E(this._metaframes, (n) => {
      delete n[t];
    }), this._state = E(this._state, (n) => {
      delete n.metaframes.inputs[t], delete n.metaframes.outputs[t];
    }), this._inputMap = E(this._inputMap, (n) => {
      delete n[t], Object.keys(n).forEach((s) => {
        const i = n[s];
        let o = 0;
        for (; o <= i.length; )
          i[o] && i[o].metaframe === t ? i.splice(o, 1) : o++;
      });
    }), this._cachedInputLookupMap = E({}, (n) => n));
  }
  removeAll() {
    Object.keys(this._metaframes).forEach((t) => this._metaframes[t].dispose()), this._metaframes = E({}, (t) => t), this._state = ye, this._inputMap = E({}, (t) => t), this._cachedInputLookupMap = E({}, (t) => t);
  }
  metaframes() {
    return this.getMetaframes();
  }
  metaframeIds() {
    return this.getMetaframeIds();
  }
  getMetaframeIds() {
    return Object.keys(this._metaframes);
  }
  getMetaframes() {
    return this._metaframes;
  }
  getMetaframe(t) {
    return this == null ? void 0 : this._metaframes[t];
  }
  addMetaframe(t, n) {
    if (!t)
      throw "addMetaframe missing metaframeId";
    if (!n)
      throw "addMetaframe missing definition";
    if (this._metaframes[t])
      throw this.emitErrorMessage(`Existing metaframe for id=${t}`), `Existing metaframe for id=${t}`;
    if (!n.url)
      throw this.emitErrorMessage(`Metaframe definition missing url id=${t}`), `Metaframe definition missing url id=${t}`;
    var s = new mi(this, n.url, t, this._id, this._consoleBackgroundColor, this.debug).setMetapage(this);
    return this._metaframes = E(this._metaframes, (i) => {
      i[t] = s;
    }), s.addListener(M.Error, (i) => {
      this.emit(M.Error, {
        metaframeId: s.id,
        metaframeUrl: s.url,
        error: i
      });
    }), n.inputs && n.inputs.forEach((i) => this.addPipe(t, i)), s.setInputs(this._state.metaframes.inputs[t]), s;
  }
  dispose() {
    this.log("disposing"), super.removeAllListeners(), window.removeEventListener("message", this.onMessage), this._metaframes && Object.keys(this._metaframes).forEach((t) => this._metaframes[t].dispose()), this._id = void 0, this._metaframes = void 0, this._state = void 0, this._cachedInputLookupMap = void 0, this._inputMap = void 0;
  }
  log(t, n, s) {
    this.debug && this.logInternal(t, n, s);
  }
  error(t) {
    this.logInternal(t, "f00", this._consoleBackgroundColor), this.emitErrorMessage(`${t}`);
  }
  emitErrorMessage(t) {
    this.emit(M.Error, t);
  }
  getInputsFromOutput(t, n) {
    return this._cachedInputLookupMap[t] || (this._cachedInputLookupMap = E(this._cachedInputLookupMap, (s) => {
      s[t] = E({}, (i) => i);
    })), this._cachedInputLookupMap[t][n] || (this._cachedInputLookupMap = E(this._cachedInputLookupMap, (s) => {
      var i = [];
      s[t][n] = i, Object.keys(this._inputMap).forEach((o) => {
        o !== t && this._inputMap[o].forEach((r) => {
          if (r.metaframe === t && yi(n, r.source)) {
            var a = r.target || "";
            !r.target || r.target.startsWith("*") || r.target === "" ? a = n : a && a.endsWith("/") && (a = a + n), i.push({ metaframe: o, pipe: a });
          }
        });
      });
    })), this._cachedInputLookupMap[t][n];
  }
  isValidJSONRpcMessage(t) {
    if (t.jsonrpc !== "2.0")
      return !1;
    switch (t.method) {
      case X.SetupIframeClientRequest:
        return !0;
      default:
        var s = t.iframeId;
        return !(s && !(t.parentId === this._id && this._metaframes[s]));
    }
  }
  setInput(t, n, s) {
    var i, o;
    typeof t == "object" ? this.setInputStateOnlyMetapageInstanceInputs(t) : typeof n == "string" ? this.setInputStateOnlyMetaframeInputValue(t, n, s) : this.setInputStateOnlyMetaframeInputMap(t, n || {}), this.setMetaframeClientInputAndSentClientEvent(t, n, s), (this.listenerCount(M.State) > 0 || this.listenerCount(M.Inputs) > 0) && ye !== this._state && (this.emit(M.State, this._state), this.emit(M.Inputs, (o = (i = this._state) == null ? void 0 : i.metaframes) == null ? void 0 : o.inputs));
  }
  setMetaframeClientInputAndSentClientEvent(t, n, s) {
    if (typeof t == "object") {
      if (n || s)
        throw "bad arguments, see API docs";
      const i = t;
      Object.keys(i).forEach((o) => {
        var r = o, a = i[r];
        if (typeof a != "object")
          throw "bad arguments, see API docs";
        var u = this._metaframes[r];
        u ? u.setInputs(a) : this.error("No iframe id=$metaframeId");
      });
    } else if (typeof t == "string") {
      const i = this._metaframes[t];
      if (i == null && this.error(`No iframe id=${t}`), typeof n == "string")
        i.setInput(n, s);
      else if (typeof n == "object")
        i.setInputs(n);
      else
        throw "bad arguments, see API docs";
    } else
      throw "bad arguments, see API docs";
  }
  setInputs(t, n, s) {
    this.setInput(t, n, s);
  }
  setOutputStateOnlyMetapageInstanceInputs(t) {
    this._setStateOnlyMetaframes(!1, t);
  }
  setOutputStateOnlyMetaframeInputValue(t, n, s) {
    this._setStateOnlyMetaframeInputValue(!1, t, n, s);
  }
  setOutputStateOnlyMetaframeInputMap(t, n) {
    this._setStateOnlyMetaframeInputMap(!1, t, n);
  }
  setInputStateOnlyMetapageInstanceInputs(t) {
    this._setStateOnlyMetaframes(!0, t);
  }
  setInputStateOnlyMetaframeInputValue(t, n, s) {
    this._setStateOnlyMetaframeInputValue(!0, t, n, s);
  }
  setInputStateOnlyMetaframeInputMap(t, n) {
    this._setStateOnlyMetaframeInputMap(!0, t, n);
  }
  _setStateOnlyMetaframeInputValue(t, n, s, i) {
    this._state = E(this._state, (o) => {
      if (!this._metaframes.hasOwnProperty(n))
        throw `No metaframe: ${n}`;
      o.metaframes || (o.metaframes = { inputs: {}, outputs: {} }), t ? o.metaframes.inputs || (o.metaframes.inputs = {}) : o.metaframes.outputs || (o.metaframes.outputs = {});
      let a = t ? o.metaframes.inputs : o.metaframes.outputs;
      a = a || {}, a[n] = a[n] ? a[n] : {}, i === void 0 ? delete a[n][s] : a[n][s] = i;
    });
  }
  _setStateOnlyMetaframeInputMap(t, n, s) {
    !s || Object.keys(s).length === 0 || (this._state = E(this._state, (i) => {
      if (!this._metaframes.hasOwnProperty(n))
        throw `No metaframe: ${n}`;
      let r = t ? i.metaframes.inputs : i.metaframes.outputs;
      r[n] = r[n] ? r[n] : {}, Object.keys(s).forEach((a) => {
        s[a] === void 0 ? delete r[n][a] : r[n][a] = s[a];
      });
    }));
  }
  _setStateOnlyMetaframes(t, n) {
    !n || Object.keys(n).length === 0 || (this._state = E(this._state, (s) => {
      Object.keys(n).forEach((i) => {
        var o = n[i];
        if (typeof o != "object")
          throw "Object values must be objects";
        if (!this._metaframes.hasOwnProperty(i))
          throw "No metaframe: ${metaframeId}";
        const a = t ? s.metaframes.inputs : s.metaframes.outputs;
        a[i] = a[i] ? a[i] : {}, Object.keys(o).forEach((u) => {
          o[u] === void 0 ? delete a[i][u] : a[i][u] = o[u];
        });
      });
    }));
  }
  onMessage(t) {
    if (typeof t.data == "object") {
      const r = t.data;
      if (!this.isValidJSONRpcMessage(r))
        return;
      var n = r.method;
      const a = r.iframeId;
      if (!a)
        return;
      const u = this.getMetaframe(a);
      if (!u) {
        this.error(`💥 onMessage no metaframe id=${a}`);
        return;
      }
      switch (r._messageCount = ++this._internalReceivedMessageCounter, this.debug && this.log(`processing ${JSON.stringify(r, null, "  ").substring(0, 500)}`), n) {
        case X.SetupIframeClientRequest:
          u.register();
          break;
        case X.SetupIframeServerResponseAck:
          if (u) {
            const c = r.params;
            u.registered(c.version);
          }
          break;
        case X.OutputsUpdate:
          const f = r.params;
          if (!f || Object.keys(f).length === 0)
            break;
          if (this._metaframes[a]) {
            var s = this._metaframes[a];
            this.setOutputStateOnlyMetaframeInputMap(a, f), s.setOutputs(f);
            var i = !1;
            const c = Object.keys(f), d = {};
            c.forEach((y, w) => {
              const _ = this.getInputsFromOutput(a, y);
              _.length > 0 && _.forEach((S) => {
                d[S.metaframe] || (d[S.metaframe] = {}), d[S.metaframe][S.pipe] = f[y], i = !0;
              });
            }), i && (this.setInputStateOnlyMetapageInstanceInputs(d), Object.keys(d).forEach((y) => {
              this._metaframes[y].setInputs(d[y]);
            })), this.listenerCount(M.State) > 0 && ye !== this._state && this.emit(M.State, this._state), this.debug && s.ack({ jsonrpc: r, state: this._state });
          } else
            this.error(`missing metaframe=${a}`);
          break;
        case X.InputsUpdate:
          var o = r.params;
          this.debug && this.log(`inputs ${JSON.stringify(o)} from ${a}`), this._metaframes[a] ? (this.setInputStateOnlyMetaframeInputMap(a, o), this._metaframes[a].setInputs(o), this.listenerCount(M.State) > 0 && ye !== this._state && this.emit(M.State, this._state), this.debug && this._metaframes[a].ack({
            jsonrpc: r,
            state: this._state
          })) : (console.error(`InputsUpdate failed no metaframe id: "${a}"`), this.error(`InputsUpdate failed no metaframe id: "${a}"`));
          break;
        case X.HashParamsUpdate:
          if (u) {
            const c = r.params, d = new URL(u.url);
            d.hash = c.hash, u.url = d.href, this._definition = E(this._definition, (y) => {
              y.metaframes[c.metaframe].url = d.href;
            }), this._emitDefinitionEvent();
          }
          break;
        default:
          this.debug && this.log(`Unknown RPC method: "${n}"`);
      }
      this.listenerCount(M.Message) > 0 && this.emit(M.Message, r);
    }
  }
  logInternal(t, n, s) {
    s = s || this._consoleBackgroundColor;
    let i;
    typeof t == "string" ? i = t : typeof t == "number" ? i = t + "" : i = JSON.stringify(t), i = this._id ? `Metapage[${this._id}] ${i}` : i, Rt(i, n, s);
  }
}
ne.version = Gt;
ne.DEFINITION = M.Definition;
ne.ERROR = M.Error;
ne.INPUTS = M.Inputs;
ne.MESSAGE = M.Message;
ne.OUTPUTS = M.Outputs;
ne.STATE = M.State;
ne.deserializeInputs = Ce;
ne.serializeInputs = We;
export {
  ln as INITIAL_NULL_METAPAGE_DEFINITION,
  Mi as INTERNAL_ERROR,
  Ei as INVALID_PARAMS,
  Ai as INVALID_REQUEST,
  X as JsonRpcMethodsFromChild,
  fe as JsonRpcMethodsFromParent,
  gi as METAFRAME_JSON_FILE,
  bi as METAPAGE_KEY_DEFINITION,
  vi as METAPAGE_KEY_STATE,
  Si as METHOD_NOT_FOUND,
  te as Metaframe,
  U as MetaframeEvents,
  re as MetaframeLoadingState,
  pt as MetaframeVersionCurrent,
  Et as MetaframeVersionsAll,
  ne as Metapage,
  M as MetapageEvents,
  xe as MetapageHashParams,
  mi as MetapageIFrameRpcClient,
  Ps as MetapageShared,
  Je as MetapageVersionCurrent,
  Mt as MetapageVersionsAll,
  Oi as PARSE_ERROR,
  An as VERSION_METAFRAME,
  Gt as VERSION_METAPAGE,
  Yn as convertMetaframeDefinitionToCurrentVersion,
  en as convertMetaframeDefinitionToVersion,
  es as convertMetaframeJsonToCurrentVersion,
  Vn as convertMetapageDefinitionToCurrentVersion,
  Zt as convertMetapageDefinitionToVersion,
  Ce as deserializeInputs,
  wt as generateId,
  xi as generateMetaframeId,
  Ts as generateMetapageId,
  Li as generateNonce,
  ki as getLibraryVersionMatching,
  ue as getMatchingMetaframeVersion,
  Re as getMatchingMetapageVersion,
  di as getMetaframeDefinitionFromUrl,
  Di as getMetapageDefinitionFromUrl,
  Ci as getUrlParam,
  $i as getUrlParamDebug,
  Ds as hashCode,
  Hs as intToRGB,
  ft as isDebugFromUrlsParams,
  Hi as isEmptyMetaframeDefinition,
  Ls as isIframe,
  Ii as isJsonRpcId,
  Ze as isPageLoaded,
  Rt as log,
  yi as matchPipe,
  ze as merge,
  Pi as metapageAllSha256Hash,
  Ti as metapageOnlyEssentailSha256Hash,
  Ot as pageLoaded,
  Ri as possiblyDeserializeDatarefToFile,
  tn as possiblyDeserializeDatarefToValue,
  cs as possiblySerializeValueToDataref,
  We as serializeInputs,
  pn as stringToRgb,
  wi as valueToFile
};
//# sourceMappingURL=index.js.map
